"use strict";
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  animation: spinner 0.6s linear infinite;\n\n  @keyframes spinner {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  justify-content: center;\n  align-items: center;\n  padding: none;\n  width: 42px;\n  height: 42px;\n  > * {\n    // TODO: Replace with Icon when implemented\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--gradient-blurple);\n  color: var(--color-neutral-0);\n\n  :active:not([disabled]) {\n    border-color: var(--color-blurple-700);\n  }\n\n  &[disabled] {\n    background: var(--color-neutral-300);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  border-left-color: var(--color-blurple-600);\n  border-right-color: #7d52ff;\n  transition: box-shadow 0.5s;\n\n  :hover:not(:active):not([disabled]) {\n    background: var(--color-blurple-700);\n  }\n\n  :active:not([disabled]) {\n    border-color: transparent;\n  }\n\n  &[disabled] {\n    background: var(--color-neutral-300);\n    border-color: transparent;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  background: transparent;\n  border-color: var(--color-blurple-600);\n  color: var(--color-blurple-600);\n\n  :hover:not(:active):not([disabled]) {\n    background: var(--color-blurple-100);\n    color: var(--color-blurple-700);\n  }\n\n  :active:not([disabled]) {\n    background: var(--color-blurple-200);\n    color: var(--color-blurple-700);\n  }\n\n  &[disabled] {\n    color: var(--color-neutral-500);\n    border-color: var(--color-neutral-200);\n    background: transparent;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  background: transparent;\n  border-color: none;\n  color: var(--color-blurple-600);\n\n  :hover:not(:active):not([disabled]) {\n    background: var(--color-blurple-100);\n    color: var(--color-blurple-700);\n  }\n\n  :active:not([disabled]) {\n    background: var(--color-blurple-200);\n    color: var(--color-blurple-700);\n    border-color: transparent;\n  }\n\n  &[disabled] {\n    color: var(--color-neutral-500);\n    border-color: none;\n    background: transparent;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--color-pink-600);\n  border-color: none;\n  color: var(--color-neutral-0);\n\n  :hover:not(:active):not([disabled]) {\n    background: var(--color-pink-700);\n  }\n\n  :active:not([disabled]) {\n    border-color: transparent;\n  }\n\n  &[disabled] {\n    background: var(--color-neutral-300);\n    border-color: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  pointer-events: none;\n  color: transparent;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 40px;\n  border-width: var(--border-width-x-small);\n  border-color: transparent;\n  border-style: solid;\n  padding: var(--spacing-small) var(--spacing-regular);\n  position: relative;\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-regular);\n  border-radius: var(--border-radius-small);\n  letter-spacing: var(--letter-spacing-regular);\n  line-height: var(--line-height-regular);\n  cursor: pointer;\n  display: inline-flex;\n  gap: var(--spacing-small);\n  justify-content: center;\n  transition: background 0.3s ease, box-shadow 0.5s ease;\n  outline-offset: 4px;\n  outline-color: var(--color-blue-600);\n\n  &[disabled] {\n    cursor: not-allowed;\n  }\n\n  :active:not([disabled]) {\n    box-shadow: rgb(189 199 219) 0px 1px 4px, rgb(189 199 219) 0px 0px 0px 3px;\n  }\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "  \n  ",
        "  \n  &[disabled] {\n    ",
        "\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--icon-size-small);\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--icon-size-regular);\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--icon-size-large);\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--icon-size-x-large);\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: var(--spacing-regular);\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--progress-default);\n  height: 100%;\n  border-top-left-radius: 100px;\n  border-bottom-left-radius: 100px;\n  transition: 0.25s ease;\n  background: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  height: 6px;\n  min-width: 100px;\n  border-radius: 100px;\n  overflow: hidden;\n  box-shadow: var(--elevation-basement);\n\n  background: ",
        ";\n\n  &[data-value='100'] {\n    ",
        " {\n      border-top-right-radius: 100px;\n      border-bottom-right-radius: 100px;\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: var(--border-radius-small);\n  min-height: 96px;\n  box-shadow: var(--elevation-100);\n  padding: var(--spacing-x-large);\n  background: var(--color-neutral-0);\n\n  & & {\n    box-shadow: none;\n    border: 1px solid var(--color-neutral-200);\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  font-family: var(--font-family-mono);\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-small);\n  line-height: var(--line-height-400);\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-regular);\n  line-height: var(--line-height-regular);\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-large);\n  line-height: var(--line-height-200);\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-x-large);\n  line-height: var(--line-height-200);\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-x-x-large);\n  letter-spacing: var(--letter-spacing-dense);\n  line-height: var(--line-height-100);\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--font-weight-bold);\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--font-weight-semibold);\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--font-weight-regular);\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  letter-spacing: var(--letter-spacing-dense);\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  letter-spacing: var(--letter-spacing-regular);\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  letter-spacing: var(--letter-spacing-spacious);\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: var(--line-height-x-small);\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: var(--line-height-small);\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: var(--line-height-regular);\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: var(--line-height-large);\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n   ",
        "\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  text-transform: uppercase;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-neutral-800);\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: var(--spacing-x-small);\n  color: var(--color-neutral-800);\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: var(--spacing-regular);\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: baseline;\n  cursor: pointer;\n  color: var(--color-blurple-600);\n  text-decoration: none;\n  gap: ",
        ";\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    border-radius: var(--border-radius-small);\n    outline-offset: 1px;\n    outline-color: var(--color-blue-600);\n    outline-width: var(--border-width-small);\n  }\n\n  &:active {\n    color: var(--color-blurple-700);\n  }\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--font-weight-bold);\n  font-size: ",
        ";\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n  .st0 {\n    fill: #fff;\n  }\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.2);\n  }\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    left: 18px;\n    ",
        ": 18px;\n  }\n  100% {\n    left: 18px;\n    ",
        ": 42px;\n  }\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    background: transparent;\n    border: 4px solid transparent;\n\n    ",
        "\n  }\n  100% {\n    background: transparent;\n    border: 4px solid transparent;\n    height: 50px;\n    left: -5px;\n    width: 50px;\n\n    ",
        ": -2px;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 0.6s ease-in-out 1, ",
        " 1.5s linear 0.5s infinite;\n  background: var(--gradient-blurple);\n  border-radius: 50%;\n  display: block;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  height: 40px;\n  position: relative;\n  transform: translateZ(0);\n  width: 40px;\n  will-change: transform;\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n    animation: ",
        " 0.5s linear 1 0.5s forwards,\n      ",
        " 0.5s linear 1 1s forwards,\n      ",
        " 0.5s linear 1 3s forwards;\n\n    ",
        ": 18px;\n  "
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--color-blurple-600);\n  border-radius: 50%;\n  height: 6px;\n  left: 18px;\n  position: absolute;\n  width: 6px;\n  transform: translateZ(0);\n  will-change: transform;\n\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  animation: ",
        " 0.6s ease-in-out 1;\n  background: var(--gradient-blurple);\n  border-radius: 100%;\n  display: flex;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  height: 40px;\n  justify-content: center;\n  position: absolute;\n  transform: translateZ(0);\n  width: 40px;\n  will-change: transform;\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        "\n  width: 20px;\n  height: 20px;\n"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-weight-bold);\n  letter-spacing: var(--letter-spacing-regular);\n  line-height: var(--line-height-regular);\n  color: var(--color-neutral-800);\n"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  outline: none;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-regular);\n  line-height: var(--line-height-regular);\n  color: var(--color-neutral-800);\n  padding: 0;\n  ::placeholder {\n    font-style: italic;\n    color: var(--color-neutral-600);\n  }\n"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding-left: var(--spacing-small);\n"
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding-right: var(--spacing-small);\n"
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-neutral-50);\n  border: var(--border-width-x-small) solid var(--color-neutral-200);\n  background: var(--color-neutral-50);\n  outline: none;\n  cursor: not-allowed;\n\n  ",
        " {\n    background: var(--color-neutral-50);\n    cursor: not-allowed;\n    ::placeholder {\n      color: var(--color-neutral-500);\n    }\n  }\n\n  &:hover {\n    outline: none;\n    border: var(--border-width-x-small) solid var(--color-neutral-200);\n  }\n"
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-pink-50);\n  border: var(--border-width-x-small) solid var(--color-pink-600);\n\n  &:hover {\n    border: var(--border-width-x-small) solid var(--color-pink-700);\n  }\n\n  &:focus-within {\n    outline: var(--border-width-small) solid var(--color-pink-300);\n    border: var(--border-width-x-small) solid var(--color-pink-700);\n  }\n"
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--color-neutral-0);\n  border: var(--border-width-x-small) solid var(--color-neutral-500);\n  outline: none;\n"
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _taggedTemplateLiteral([
        "\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0;\n  outline-color: var(--color-blue-600);\n"
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-neutral-700);\n  padding-right: var(--spacing-small);\n"
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ",",
        ",",
        " {\n    font-size: var(--font-size-small);\n  }\n\n  ",
        " {\n    font-size: var(--icon-size-small);\n  }\n"
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  min-height: 42px;\n  background-color: var(--color-neutral-0);\n  border: var(--border-width-x-small) solid var(--color-neutral-500);\n  border-radius: var(--border-radius-small);\n  padding: var(--spacing-small) var(--spacing-regular);\n\n  &:hover {\n    outline: none;\n    border: var(--border-width-x-small) solid var(--color-neutral-700);\n  }\n\n  &:focus-within {\n    outline: var(--border-width-small) solid var(--color-blue-300);\n    border: var(--border-width-x-small) solid var(--color-blue-600);\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 0 0 var(--spacing-regular);\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding-right: var(--spacing-small);\n  font-size: var(--icon-size-regular);\n"
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  outline: none;\n  border-radius: var(--border-radius-small);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-regular);\n  line-height: var(--line-height-regular);\n  color: var(--color-neutral-800);\n  padding: var(--spacing-small) var(--spacing-regular);\n  min-height: 40px;\n\n  ::placeholder {\n    font-style: italic;\n    color: var(--color-neutral-600);\n  }\n"
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-neutral-50);\n  border: var(--border-width-x-small) solid var(--color-neutral-200);\n  background: var(--color-neutral-50);\n  outline: none;\n  cursor: not-allowed;\n\n  ",
        " {\n    background: var(--color-neutral-50);\n    cursor: not-allowed;\n  }\n\n  &:hover {\n    outline: none;\n    border: var(--border-width-x-small) solid var(--color-neutral-200);\n  }\n"
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-pink-50);\n  border: var(--border-width-x-small) solid var(--color-pink-600);\n\n  &:hover {\n    border: var(--border-width-x-small) solid var(--color-pink-700);\n  }\n\n  &:focus-within {\n    outline: var(--border-width-small) solid var(--color-pink-300);\n    border: var(--border-width-x-small) solid var(--color-pink-700);\n  }\n"
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--color-neutral-0);\n  border: var(--border-width-x-small) solid var(--color-neutral-500);\n  outline: none;\n"
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-neutral-700);\n  text-align: right;\n  line-height: var(--line-height-regular);\n  height: calc(var(--spacing-large) + var(--spacing-x-small));\n  padding: var(--spacing-x-small) var(--spacing-regular);\n"
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ", ",
        " {\n    font-size: var(--font-size-small);\n  }\n  ",
        " {\n    padding-top: var(--spacing-small);\n  }\n"
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  resize: both;\n  overflow: hidden;\n  position: relative;\n  padding: var(--spacing-small) 0 0;\n  min-height: calc(40px + 36px);\n\n  ",
        " {\n    resize: none;\n    padding-top: 0;\n    padding-bottom: 0;\n    flex: 1;\n  }\n"
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  overflow: hidden;\n  min-height: 40px;\n  background-color: var(--color-neutral-0);\n  border: var(--border-width-x-small) solid var(--color-neutral-500);\n  border-radius: var(--border-radius-small);\n\n  &:hover {\n    outline: none;\n    border: var(--border-width-x-small) solid var(--color-neutral-700);\n  }\n\n  &:focus-within {\n    outline: var(--border-width-small) solid var(--color-blue-300);\n  }\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = function(cb, mod) {
    return function __require() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
    "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js": function(exports) {
        "use strict";
        var z = function z(a) {
            if ("object" === typeof a && null !== a) {
                var u2 = a.$$typeof;
                switch(u2){
                    case c:
                        switch(a = a.type, a){
                            case l2:
                            case m2:
                            case e3:
                            case g:
                            case f:
                            case p2:
                                return a;
                            default:
                                switch(a = a && a.$$typeof, a){
                                    case k:
                                    case n2:
                                    case t2:
                                    case r2:
                                    case h:
                                        return a;
                                    default:
                                        return u2;
                                }
                        }
                    case d2:
                        return u2;
                }
            }
        };
        var A = function A(a) {
            return z(a) === m2;
        };
        var b = "function" === typeof Symbol && Symbol.for;
        var c = b ? Symbol.for("react.element") : 60103;
        var d2 = b ? Symbol.for("react.portal") : 60106;
        var e3 = b ? Symbol.for("react.fragment") : 60107;
        var f = b ? Symbol.for("react.strict_mode") : 60108;
        var g = b ? Symbol.for("react.profiler") : 60114;
        var h = b ? Symbol.for("react.provider") : 60109;
        var k = b ? Symbol.for("react.context") : 60110;
        var l2 = b ? Symbol.for("react.async_mode") : 60111;
        var m2 = b ? Symbol.for("react.concurrent_mode") : 60111;
        var n2 = b ? Symbol.for("react.forward_ref") : 60112;
        var p2 = b ? Symbol.for("react.suspense") : 60113;
        var q = b ? Symbol.for("react.suspense_list") : 60120;
        var r2 = b ? Symbol.for("react.memo") : 60115;
        var t2 = b ? Symbol.for("react.lazy") : 60116;
        var v = b ? Symbol.for("react.block") : 60121;
        var w2 = b ? Symbol.for("react.fundamental") : 60117;
        var x = b ? Symbol.for("react.responder") : 60118;
        var y = b ? Symbol.for("react.scope") : 60119;
        exports.AsyncMode = l2;
        exports.ConcurrentMode = m2;
        exports.ContextConsumer = k;
        exports.ContextProvider = h;
        exports.Element = c;
        exports.ForwardRef = n2;
        exports.Fragment = e3;
        exports.Lazy = t2;
        exports.Memo = r2;
        exports.Portal = d2;
        exports.Profiler = g;
        exports.StrictMode = f;
        exports.Suspense = p2;
        exports.isAsyncMode = function(a) {
            return A(a) || z(a) === l2;
        };
        exports.isConcurrentMode = A;
        exports.isContextConsumer = function(a) {
            return z(a) === k;
        };
        exports.isContextProvider = function(a) {
            return z(a) === h;
        };
        exports.isElement = function(a) {
            return "object" === typeof a && null !== a && a.$$typeof === c;
        };
        exports.isForwardRef = function(a) {
            return z(a) === n2;
        };
        exports.isFragment = function(a) {
            return z(a) === e3;
        };
        exports.isLazy = function(a) {
            return z(a) === t2;
        };
        exports.isMemo = function(a) {
            return z(a) === r2;
        };
        exports.isPortal = function(a) {
            return z(a) === d2;
        };
        exports.isProfiler = function(a) {
            return z(a) === g;
        };
        exports.isStrictMode = function(a) {
            return z(a) === f;
        };
        exports.isSuspense = function(a) {
            return z(a) === p2;
        };
        exports.isValidElementType = function(a) {
            return "string" === typeof a || "function" === typeof a || a === e3 || a === m2 || a === g || a === f || a === p2 || a === q || "object" === typeof a && null !== a && (a.$$typeof === t2 || a.$$typeof === r2 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n2 || a.$$typeof === w2 || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
        };
        exports.typeOf = z;
    }
});
// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
    "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js": function(exports) {
        "use strict";
        if (process.env.NODE_ENV !== "production") {
            (function() {
                "use strict";
                var isValidElementType = function isValidElementType(type) {
                    return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
                };
                var typeOf = function typeOf(object) {
                    if (typeof object === "object" && object !== null) {
                        var $$typeof = object.$$typeof;
                        switch($$typeof){
                            case REACT_ELEMENT_TYPE:
                                var type = object.type;
                                switch(type){
                                    case REACT_ASYNC_MODE_TYPE:
                                    case REACT_CONCURRENT_MODE_TYPE:
                                    case REACT_FRAGMENT_TYPE:
                                    case REACT_PROFILER_TYPE:
                                    case REACT_STRICT_MODE_TYPE:
                                    case REACT_SUSPENSE_TYPE:
                                        return type;
                                    default:
                                        var $$typeofType = type && type.$$typeof;
                                        switch($$typeofType){
                                            case REACT_CONTEXT_TYPE:
                                            case REACT_FORWARD_REF_TYPE:
                                            case REACT_LAZY_TYPE:
                                            case REACT_MEMO_TYPE:
                                            case REACT_PROVIDER_TYPE:
                                                return $$typeofType;
                                            default:
                                                return $$typeof;
                                        }
                                }
                            case REACT_PORTAL_TYPE:
                                return $$typeof;
                        }
                    }
                    return void 0;
                };
                var isAsyncMode = function isAsyncMode(object) {
                    {
                        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                            hasWarnedAboutDeprecatedIsAsyncMode = true;
                            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
                        }
                    }
                    return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
                };
                var isConcurrentMode = function isConcurrentMode(object) {
                    return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
                };
                var isContextConsumer = function isContextConsumer(object) {
                    return typeOf(object) === REACT_CONTEXT_TYPE;
                };
                var isContextProvider = function isContextProvider(object) {
                    return typeOf(object) === REACT_PROVIDER_TYPE;
                };
                var isElement = function isElement(object) {
                    return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                };
                var isForwardRef = function isForwardRef(object) {
                    return typeOf(object) === REACT_FORWARD_REF_TYPE;
                };
                var isFragment = function isFragment(object) {
                    return typeOf(object) === REACT_FRAGMENT_TYPE;
                };
                var isLazy = function isLazy(object) {
                    return typeOf(object) === REACT_LAZY_TYPE;
                };
                var isMemo = function isMemo(object) {
                    return typeOf(object) === REACT_MEMO_TYPE;
                };
                var isPortal = function isPortal(object) {
                    return typeOf(object) === REACT_PORTAL_TYPE;
                };
                var isProfiler = function isProfiler(object) {
                    return typeOf(object) === REACT_PROFILER_TYPE;
                };
                var isStrictMode = function isStrictMode(object) {
                    return typeOf(object) === REACT_STRICT_MODE_TYPE;
                };
                var isSuspense = function isSuspense(object) {
                    return typeOf(object) === REACT_SUSPENSE_TYPE;
                };
                var hasSymbol = typeof Symbol === "function" && Symbol.for;
                var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
                var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
                var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
                var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
                var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
                var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
                var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
                var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
                var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
                var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
                var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
                var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
                var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
                var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
                var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
                var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
                var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
                var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
                var AsyncMode = REACT_ASYNC_MODE_TYPE;
                var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
                var ContextConsumer = REACT_CONTEXT_TYPE;
                var ContextProvider = REACT_PROVIDER_TYPE;
                var Element = REACT_ELEMENT_TYPE;
                var ForwardRef = REACT_FORWARD_REF_TYPE;
                var Fragment = REACT_FRAGMENT_TYPE;
                var Lazy = REACT_LAZY_TYPE;
                var Memo = REACT_MEMO_TYPE;
                var Portal = REACT_PORTAL_TYPE;
                var Profiler = REACT_PROFILER_TYPE;
                var StrictMode = REACT_STRICT_MODE_TYPE;
                var Suspense = REACT_SUSPENSE_TYPE;
                var hasWarnedAboutDeprecatedIsAsyncMode = false;
                exports.AsyncMode = AsyncMode;
                exports.ConcurrentMode = ConcurrentMode;
                exports.ContextConsumer = ContextConsumer;
                exports.ContextProvider = ContextProvider;
                exports.Element = Element;
                exports.ForwardRef = ForwardRef;
                exports.Fragment = Fragment;
                exports.Lazy = Lazy;
                exports.Memo = Memo;
                exports.Portal = Portal;
                exports.Profiler = Profiler;
                exports.StrictMode = StrictMode;
                exports.Suspense = Suspense;
                exports.isAsyncMode = isAsyncMode;
                exports.isConcurrentMode = isConcurrentMode;
                exports.isContextConsumer = isContextConsumer;
                exports.isContextProvider = isContextProvider;
                exports.isElement = isElement;
                exports.isForwardRef = isForwardRef;
                exports.isFragment = isFragment;
                exports.isLazy = isLazy;
                exports.isMemo = isMemo;
                exports.isPortal = isPortal;
                exports.isProfiler = isProfiler;
                exports.isStrictMode = isStrictMode;
                exports.isSuspense = isSuspense;
                exports.isValidElementType = isValidElementType;
                exports.typeOf = typeOf;
            })();
        }
    }
});
// ../../node_modules/prop-types/node_modules/react-is/index.js
var require_react_is = __commonJS({
    "../../node_modules/prop-types/node_modules/react-is/index.js": function(exports, module2) {
        "use strict";
        if (process.env.NODE_ENV === "production") {
            module2.exports = require_react_is_production_min();
        } else {
            module2.exports = require_react_is_development();
        }
    }
});
// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
    "../../node_modules/object-assign/index.js": function(exports, module2) {
        "use strict";
        var toObject = function toObject(val) {
            if (val === null || val === void 0) {
                throw new TypeError("Object.assign cannot be called with null or undefined");
            }
            return Object(val);
        };
        var shouldUseNative = function shouldUseNative() {
            try {
                if (!Object.assign) {
                    return false;
                }
                var test1 = new String("abc");
                test1[5] = "de";
                if (Object.getOwnPropertyNames(test1)[0] === "5") {
                    return false;
                }
                var test2 = {};
                for(var i2 = 0; i2 < 10; i2++){
                    test2["_" + String.fromCharCode(i2)] = i2;
                }
                var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
                    return test2[n2];
                });
                if (order2.join("") !== "0123456789") {
                    return false;
                }
                var test3 = {};
                "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                });
                if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
                    return false;
                }
                return true;
            } catch (err) {
                return false;
            }
        };
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;
        module2.exports = shouldUseNative() ? Object.assign : function(target, source) {
            var from;
            var to = toObject(target);
            var symbols;
            for(var s2 = 1; s2 < arguments.length; s2++){
                from = Object(arguments[s2]);
                for(var key in from){
                    if (hasOwnProperty.call(from, key)) {
                        to[key] = from[key];
                    }
                }
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for(var i2 = 0; i2 < symbols.length; i2++){
                        if (propIsEnumerable.call(from, symbols[i2])) {
                            to[symbols[i2]] = from[symbols[i2]];
                        }
                    }
                }
            }
            return to;
        };
    }
});
// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
    "../../node_modules/prop-types/lib/ReactPropTypesSecret.js": function(exports, module2) {
        "use strict";
        var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        module2.exports = ReactPropTypesSecret;
    }
});
// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
    "../../node_modules/prop-types/lib/has.js": function(exports, module2) {
        module2.exports = Function.call.bind(Object.prototype.hasOwnProperty);
    }
});
// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
    "../../node_modules/prop-types/checkPropTypes.js": function(exports, module2) {
        "use strict";
        var checkPropTypes = function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
            if (process.env.NODE_ENV !== "production") {
                for(var typeSpecName in typeSpecs){
                    if (has(typeSpecs, typeSpecName)) {
                        var error3;
                        try {
                            if (typeof typeSpecs[typeSpecName] !== "function") {
                                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _typeof(typeSpecs[typeSpecName]) + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                                err.name = "Invariant Violation";
                                throw err;
                            }
                            error3 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                        } catch (ex) {
                            error3 = ex;
                        }
                        if (error3 && !_instanceof(error3, Error)) {
                            printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + (typeof error3 === "undefined" ? "undefined" : _typeof(error3)) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).");
                        }
                        if (_instanceof(error3, Error) && !(error3.message in loggedTypeFailures)) {
                            loggedTypeFailures[error3.message] = true;
                            var stack = getStack ? getStack() : "";
                            printWarning("Failed " + location + " type: " + error3.message + (stack != null ? stack : ""));
                        }
                    }
                }
            }
        };
        var printWarning = function printWarning() {};
        if (process.env.NODE_ENV !== "production") {
            ReactPropTypesSecret = require_ReactPropTypesSecret();
            loggedTypeFailures = {};
            has = require_has();
            printWarning = function printWarning(text2) {
                var message = "Warning: " + text2;
                if (typeof console !== "undefined") {
                    console.error(message);
                }
                try {
                    throw new Error(message);
                } catch (x) {}
            };
        }
        var ReactPropTypesSecret;
        var loggedTypeFailures;
        var has;
        checkPropTypes.resetWarningCache = function() {
            if (process.env.NODE_ENV !== "production") {
                loggedTypeFailures = {};
            }
        };
        module2.exports = checkPropTypes;
    }
});
// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
    "../../node_modules/prop-types/factoryWithTypeCheckers.js": function(exports, module2) {
        "use strict";
        var emptyFunctionThatReturnsNull = function emptyFunctionThatReturnsNull() {
            return null;
        };
        var ReactIs = require_react_is();
        var assign = require_object_assign();
        var ReactPropTypesSecret = require_ReactPropTypesSecret();
        var has = require_has();
        var checkPropTypes = require_checkPropTypes();
        var printWarning = function printWarning() {};
        if (process.env.NODE_ENV !== "production") {
            printWarning = function printWarning(text2) {
                var message = "Warning: " + text2;
                if (typeof console !== "undefined") {
                    console.error(message);
                }
                try {
                    throw new Error(message);
                } catch (x) {}
            };
        }
        module2.exports = function(isValidElement, throwOnDirectAccess) {
            var getIteratorFn = function getIteratorFn(maybeIterable) {
                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                if (typeof iteratorFn === "function") {
                    return iteratorFn;
                }
            };
            var is = function is(x, y) {
                if (x === y) {
                    return x !== 0 || 1 / x === 1 / y;
                } else {
                    return x !== x && y !== y;
                }
            };
            var PropTypeError = function PropTypeError(message, data) {
                this.message = message;
                this.data = data && typeof data === "object" ? data : {};
                this.stack = "";
            };
            var createChainableTypeChecker = function createChainableTypeChecker(validate) {
                if (process.env.NODE_ENV !== "production") {
                    var manualPropTypeCallCache = {};
                    var manualPropTypeWarningCount = 0;
                }
                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                    componentName = componentName || ANONYMOUS;
                    propFullName = propFullName || propName;
                    if (secret !== ReactPropTypesSecret) {
                        if (throwOnDirectAccess) {
                            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                            err.name = "Invariant Violation";
                            throw err;
                        } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
                            var cacheKey = componentName + ":" + propName;
                            if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
                                printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.");
                                manualPropTypeCallCache[cacheKey] = true;
                                manualPropTypeWarningCount++;
                            }
                        }
                    }
                    if (props[propName] == null) {
                        if (isRequired) {
                            if (props[propName] === null) {
                                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                            }
                            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                        }
                        return null;
                    } else {
                        return validate(props, propName, componentName, location, propFullName);
                    }
                }
                var chainedCheckType = checkType.bind(null, false);
                chainedCheckType.isRequired = checkType.bind(null, true);
                return chainedCheckType;
            };
            var createPrimitiveTypeChecker = function createPrimitiveTypeChecker(expectedType) {
                function validate(props, propName, componentName, location, propFullName, secret) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== expectedType) {
                        var preciseType = getPreciseType(propValue);
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                            expectedType: expectedType
                        });
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var createAnyTypeChecker = function createAnyTypeChecker() {
                return createChainableTypeChecker(emptyFunctionThatReturnsNull);
            };
            var createArrayOfTypeChecker = function createArrayOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if (typeof typeChecker !== "function") {
                        return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                    }
                    var propValue = props[propName];
                    if (!Array.isArray(propValue)) {
                        var propType = getPropType(propValue);
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                    }
                    for(var i2 = 0; i2 < propValue.length; i2++){
                        var error3 = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
                        if (_instanceof(error3, Error)) {
                            return error3;
                        }
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var createElementTypeChecker = function createElementTypeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    if (!isValidElement(propValue)) {
                        var propType = getPropType(propValue);
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var createElementTypeTypeChecker = function createElementTypeTypeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    if (!ReactIs.isValidElementType(propValue)) {
                        var propType = getPropType(propValue);
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var createInstanceTypeChecker = function createInstanceTypeChecker(expectedClass) {
                function validate(props, propName, componentName, location, propFullName) {
                    if (!_instanceof(props[propName], expectedClass)) {
                        var expectedClassName = expectedClass.name || ANONYMOUS;
                        var actualClassName = getClassName(props[propName]);
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var createEnumTypeChecker = function createEnumTypeChecker(expectedValues) {
                if (!Array.isArray(expectedValues)) {
                    if (process.env.NODE_ENV !== "production") {
                        if (arguments.length > 1) {
                            printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                        } else {
                            printWarning("Invalid argument supplied to oneOf, expected an array.");
                        }
                    }
                    return emptyFunctionThatReturnsNull;
                }
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    for(var i2 = 0; i2 < expectedValues.length; i2++){
                        if (is(propValue, expectedValues[i2])) {
                            return null;
                        }
                    }
                    var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                        var type = getPreciseType(value);
                        if (type === "symbol") {
                            return String(value);
                        }
                        return value;
                    });
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                }
                return createChainableTypeChecker(validate);
            };
            var createObjectOfTypeChecker = function createObjectOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if (typeof typeChecker !== "function") {
                        return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                    }
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== "object") {
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                    }
                    for(var key in propValue){
                        if (has(propValue, key)) {
                            var error3 = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (_instanceof(error3, Error)) {
                                return error3;
                            }
                        }
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var createUnionTypeChecker = function createUnionTypeChecker(arrayOfTypeCheckers) {
                if (!Array.isArray(arrayOfTypeCheckers)) {
                    process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
                    return emptyFunctionThatReturnsNull;
                }
                for(var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++){
                    var checker = arrayOfTypeCheckers[i2];
                    if (typeof checker !== "function") {
                        printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + ".");
                        return emptyFunctionThatReturnsNull;
                    }
                }
                function validate(props, propName, componentName, location, propFullName) {
                    var expectedTypes = [];
                    for(var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++){
                        var checker2 = arrayOfTypeCheckers[i3];
                        var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                        if (checkerResult == null) {
                            return null;
                        }
                        if (checkerResult.data && has(checkerResult.data, "expectedType")) {
                            expectedTypes.push(checkerResult.data.expectedType);
                        }
                    }
                    var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
                }
                return createChainableTypeChecker(validate);
            };
            var createNodeChecker = function createNodeChecker() {
                function validate(props, propName, componentName, location, propFullName) {
                    if (!isNode(props[propName])) {
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var invalidValidatorError = function invalidValidatorError(componentName, location, propFullName, key, type) {
                return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
            };
            var createShapeTypeChecker = function createShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== "object") {
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                    }
                    for(var key in shapeTypes){
                        var checker = shapeTypes[key];
                        if (typeof checker !== "function") {
                            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                        }
                        var error3 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error3) {
                            return error3;
                        }
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var createStrictShapeTypeChecker = function createStrictShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== "object") {
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                    }
                    var allKeys = assign({}, props[propName], shapeTypes);
                    for(var key in allKeys){
                        var checker = shapeTypes[key];
                        if (has(shapeTypes, key) && typeof checker !== "function") {
                            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                        }
                        if (!checker) {
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                        }
                        var error3 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error3) {
                            return error3;
                        }
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            };
            var isSymbol = function isSymbol(propType, propValue) {
                if (propType === "symbol") {
                    return true;
                }
                if (!propValue) {
                    return false;
                }
                if (propValue["@@toStringTag"] === "Symbol") {
                    return true;
                }
                if (typeof Symbol === "function" && _instanceof(propValue, Symbol)) {
                    return true;
                }
                return false;
            };
            var getPropType = function getPropType(propValue) {
                var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
                if (Array.isArray(propValue)) {
                    return "array";
                }
                if (_instanceof(propValue, RegExp)) {
                    return "object";
                }
                if (isSymbol(propType, propValue)) {
                    return "symbol";
                }
                return propType;
            };
            var getPreciseType = function getPreciseType(propValue) {
                if (typeof propValue === "undefined" || propValue === null) {
                    return "" + propValue;
                }
                var propType = getPropType(propValue);
                if (propType === "object") {
                    if (_instanceof(propValue, Date)) {
                        return "date";
                    } else if (_instanceof(propValue, RegExp)) {
                        return "regexp";
                    }
                }
                return propType;
            };
            var getPostfixForTypeWarning = function getPostfixForTypeWarning(value) {
                var type = getPreciseType(value);
                switch(type){
                    case "array":
                    case "object":
                        return "an " + type;
                    case "boolean":
                    case "date":
                    case "regexp":
                        return "a " + type;
                    default:
                        return type;
                }
            };
            var getClassName = function getClassName(propValue) {
                if (!propValue.constructor || !propValue.constructor.name) {
                    return ANONYMOUS;
                }
                return propValue.constructor.name;
            };
            var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
            var FAUX_ITERATOR_SYMBOL = "@@iterator";
            var ANONYMOUS = "<<anonymous>>";
            var ReactPropTypes = {
                array: createPrimitiveTypeChecker("array"),
                bigint: createPrimitiveTypeChecker("bigint"),
                bool: createPrimitiveTypeChecker("boolean"),
                func: createPrimitiveTypeChecker("function"),
                number: createPrimitiveTypeChecker("number"),
                object: createPrimitiveTypeChecker("object"),
                string: createPrimitiveTypeChecker("string"),
                symbol: createPrimitiveTypeChecker("symbol"),
                any: createAnyTypeChecker(),
                arrayOf: createArrayOfTypeChecker,
                element: createElementTypeChecker(),
                elementType: createElementTypeTypeChecker(),
                instanceOf: createInstanceTypeChecker,
                node: createNodeChecker(),
                objectOf: createObjectOfTypeChecker,
                oneOf: createEnumTypeChecker,
                oneOfType: createUnionTypeChecker,
                shape: createShapeTypeChecker,
                exact: createStrictShapeTypeChecker
            };
            PropTypeError.prototype = Error.prototype;
            function isNode(propValue) {
                switch(typeof propValue === "undefined" ? "undefined" : _typeof(propValue)){
                    case "number":
                    case "string":
                    case "undefined":
                        return true;
                    case "boolean":
                        return !propValue;
                    case "object":
                        if (Array.isArray(propValue)) {
                            return propValue.every(isNode);
                        }
                        if (propValue === null || isValidElement(propValue)) {
                            return true;
                        }
                        var iteratorFn = getIteratorFn(propValue);
                        if (iteratorFn) {
                            var iterator = iteratorFn.call(propValue);
                            var step;
                            if (iteratorFn !== propValue.entries) {
                                while(!(step = iterator.next()).done){
                                    if (!isNode(step.value)) {
                                        return false;
                                    }
                                }
                            } else {
                                while(!(step = iterator.next()).done){
                                    var entry = step.value;
                                    if (entry) {
                                        if (!isNode(entry[1])) {
                                            return false;
                                        }
                                    }
                                }
                            }
                        } else {
                            return false;
                        }
                        return true;
                    default:
                        return false;
                }
            }
            ReactPropTypes.checkPropTypes = checkPropTypes;
            ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
    }
});
// ../../node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
    "../../node_modules/prop-types/factoryWithThrowingShims.js": function(exports, module2) {
        "use strict";
        var emptyFunction = function emptyFunction() {};
        var emptyFunctionWithReset = function emptyFunctionWithReset() {};
        var ReactPropTypesSecret = require_ReactPropTypesSecret();
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        module2.exports = function() {
            var shim = function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) {
                    return;
                }
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = "Invariant Violation";
                throw err;
            };
            var getShim = function getShim() {
                return shim;
            };
            ;
            shim.isRequired = shim;
            ;
            var ReactPropTypes = {
                array: shim,
                bigint: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
    }
});
// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
    "../../node_modules/prop-types/index.js": function(exports, module2) {
        if (process.env.NODE_ENV !== "production") {
            ReactIs = require_react_is();
            throwOnDirectAccess = true;
            module2.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
        } else {
            module2.exports = require_factoryWithThrowingShims()();
        }
        var ReactIs;
        var throwOnDirectAccess;
    }
});
// src/index.ts
var src_exports = {};
__export(src_exports, {
    Accent: function() {
        return Accent_default;
    },
    Body100: function() {
        return Body100_default;
    },
    Body200: function() {
        return Body200_default;
    },
    Button: function() {
        return Button_default;
    },
    ButtonGroup: function() {
        return ButtonGroup_default;
    },
    Code: function() {
        return Code_default;
    },
    Heading: function() {
        return Heading_default;
    },
    Heading100: function() {
        return Heading100_default;
    },
    Heading200: function() {
        return Heading200_default;
    },
    Heading300: function() {
        return Heading300_default;
    },
    Icon: function() {
        return Icon_default;
    },
    InlineMessage: function() {
        return InlineMessage_default;
    },
    Input: function() {
        return Input_default;
    },
    Label: function() {
        return Label_default;
    },
    Link: function() {
        return Link_default;
    },
    Paragraph: function() {
        return Paragraph_default;
    },
    Progress: function() {
        return Progress_default;
    },
    Section: function() {
        return Section_default;
    },
    Spinner: function() {
        return Spinner_default;
    },
    Text: function() {
        return Text_default;
    },
    TextArea: function() {
        return TextArea_default;
    }
});
module.exports = __toCommonJS(src_exports);
// src/components/Button/Button.tsx
var import_styled_components2 = __toESM(require("styled-components"));
// src/contexts/telemetry-context.tsx
var import_react = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var noop = function() {
    return void 0;
};
var TelemetryContext = import_react.default.createContext({
    enabled: false,
    performance: {},
    reset: noop
});
var useTelemetryContext = function() {
    var context = (0, import_react.useContext)(TelemetryContext);
    if (process.env.NODE_ENV === "development" && context === void 0) {
        console.warn("TelemetryContext could not be found.");
        return {
            performance: {}
        };
    }
    return context;
};
// src/hooks/use-telemetry.ts
var import_react2 = require("react");
var getTelemetry = function(displayName, telemetry, isFirstRenderRef) {
    var start = -1;
    var end3 = -1;
    var setStart = function() {
        if (telemetry === null || telemetry === void 0 ? void 0 : telemetry.enabled) {
            start = performance.now();
            if (!telemetry.performance[displayName]) {
                telemetry.performance[displayName] = {
                    instances: 0,
                    renders: 0,
                    msTotal: 0,
                    msMin: Number.MAX_SAFE_INTEGER,
                    msMax: 0
                };
            }
        }
    };
    var setEnd = function() {
        if ((telemetry === null || telemetry === void 0 ? void 0 : telemetry.enabled) && start !== -1) {
            end3 = performance.now();
            var duration = end3 - start;
            telemetry.performance[displayName].instances += Number(isFirstRenderRef.current);
            telemetry.performance[displayName].renders++;
            telemetry.performance[displayName].msTotal += duration;
            telemetry.performance[displayName].msMin = Math.min(duration, telemetry.performance[displayName].msMin);
            telemetry.performance[displayName].msMax = Math.max(duration, telemetry.performance[displayName].msMax);
            isFirstRenderRef.current = false;
        }
    };
    return {
        setStart: setStart,
        setEnd: setEnd
    };
};
var useTelemetry = function(displayName, context) {
    var isFirstRenderRef = (0, import_react2.useRef)(true);
    return getTelemetry(displayName, context, isFirstRenderRef);
};
// src/components/Button/loading.svg
var loading_default = "./loading-XGQEYDCS.svg";
// src/components/Button/styled.ts
var import_styled_components = __toESM(require("styled-components"));
var LoadingSpinner = import_styled_components.default.img(_templateObject());
var LoadingWrapper = import_styled_components.default.div(_templateObject1());
var iconOnly = import_styled_components.css(_templateObject2());
var base = import_styled_components.css(_templateObject3());
var primary = import_styled_components.css(_templateObject4());
var secondary = import_styled_components.css(_templateObject5());
var tertiary = import_styled_components.css(_templateObject6());
var destructive = import_styled_components.css(_templateObject7());
var fluid = import_styled_components.css(_templateObject8());
var loading = import_styled_components.css(_templateObject9());
var Button = import_styled_components.default.button(_templateObject10(), base, function(props) {
    return props.$variant === "primary" && primary;
}, function(props) {
    return props.$variant === "secondary" && secondary;
}, function(props) {
    return props.$variant === "tertiary" && tertiary;
}, function(props) {
    return props.$variant === "destructive" && destructive;
}, function(props) {
    return props.$loading && loading;
}, function(props) {
    return props.$loading && loading;
}, function(props) {
    return props.$iconOnly && iconOnly;
}, function(props) {
    return props.$fluid && fluid;
});
var styled_default = {
    Button: Button,
    LoadingWrapper: LoadingWrapper,
    LoadingSpinner: LoadingSpinner
};
// src/components/Button/Button.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Button2 = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, tmp = _param.iconOnly, iconOnly2 = tmp === void 0 ? false : tmp, tmp1 = _param.fluid, fluid2 = tmp1 === void 0 ? false : tmp1, tmp2 = _param.loading, loading2 = tmp2 === void 0 ? false : tmp2, children = _param.children, unhandledProps = _objectWithoutProperties(_param, [
        "variant",
        "iconOnly",
        "fluid",
        "loading",
        "children"
    ]);
    var context = useTelemetryContext();
    var ref = useTelemetry("Button", context), setStart = ref.setStart, setEnd = ref.setEnd;
    setStart();
    var element = /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(styled_default.Button, _objectSpreadProps(_objectSpread({
        $variant: variant,
        $iconOnly: iconOnly2,
        $fluid: fluid2,
        $loading: loading2
    }, unhandledProps), {
        children: [
            loading2 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(styled_default.LoadingWrapper, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(styled_default.LoadingSpinner, {
                    src: loading_default,
                    alt: "Loading"
                })
            }),
            children
        ]
    }));
    setEnd();
    return element;
};
Button2.displayName = "Button";
var Button_default = (0, import_styled_components2.default)(Button2)(_templateObject11());
// node_modules/@fortawesome/fontawesome-svg-core/index.mjs
function ownKeys1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i2 = 1; i2 < arguments.length; i2++){
        var source = null != arguments[i2] ? arguments[i2] : {};
        i2 % 2 ? ownKeys1(Object(source), true).forEach(function(key) {
            _defineProperty1(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof1(obj) {
    "@babel/helpers - typeof";
    return _typeof1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof1(obj2) {
        return typeof obj2;
    } : function(obj2) {
        return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof1(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!_instanceof(instance, Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i2 = 0; i2 < props.length; i2++){
        var descriptor = props[i2];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _slicedToArray1(arr, i2) {
    return _arrayWithHoles1(arr) || _iterableToArrayLimit1(arr, i2) || _unsupportedIterableToArray1(arr, i2) || _nonIterableRest1();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray1(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray1(arr);
}
function _arrayWithHoles1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit1(arr, i2) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i2 && _arr.length === i2) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _unsupportedIterableToArray1(o2, minLen) {
    if (!o2) return;
    if (typeof o2 === "string") return _arrayLikeToArray1(o2, minLen);
    var n2 = Object.prototype.toString.call(o2).slice(8, -1);
    if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
    if (n2 === "Map" || n2 === "Set") return Array.from(o2);
    if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray1(o2, minLen);
}
function _arrayLikeToArray1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i2 = 0, arr2 = new Array(len); i2 < len; i2++)arr2[i2] = arr[i2];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var noop2 = function noop3() {};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
    mark: noop2,
    measure: noop2
};
try {
    if (typeof window !== "undefined") _WINDOW = window;
    if (typeof document !== "undefined") _DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") _MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") _PERFORMANCE = performance;
} catch (e3) {}
var _ref = _WINDOW.navigator || {};
var _ref$userAgent = _ref.userAgent;
var userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var _familyProxy;
var _familyProxy2;
var _familyProxy3;
var _familyProxy4;
var _familyProxy5;
var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var UNITS_IN_GRID = 16;
var DEFAULT_CSS_PREFIX = "fa";
var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var DATA_FA_I2SVG = "data-fa-i2svg";
var DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var DATA_PREFIX = "data-prefix";
var DATA_ICON = "data-icon";
var HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var MUTATION_APPROACH_ASYNC = "async";
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var PRODUCTION = function() {
    try {
        return process.env.NODE_ENV === "production";
    } catch (e3) {
        return false;
    }
}();
var FAMILY_CLASSIC = "classic";
var FAMILY_SHARP = "sharp";
var FAMILIES = [
    FAMILY_CLASSIC,
    FAMILY_SHARP
];
function familyProxy(obj) {
    return new Proxy(obj, {
        get: function get2(target, prop) {
            return prop in target ? target[prop] : target[FAMILY_CLASSIC];
        }
    });
}
var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty1(_familyProxy, FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fa-kit": "kit"
}), _defineProperty1(_familyProxy, FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid"
}), _familyProxy));
var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty1(_familyProxy2, FAMILY_CLASSIC, {
    "solid": "fas",
    "regular": "far",
    "light": "fal",
    "thin": "fat",
    "duotone": "fad",
    "brands": "fab",
    "kit": "fak"
}), _defineProperty1(_familyProxy2, FAMILY_SHARP, {
    "solid": "fass"
}), _familyProxy2));
var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty1(_familyProxy3, FAMILY_CLASSIC, {
    "fab": "fa-brands",
    "fad": "fa-duotone",
    "fak": "fa-kit",
    "fal": "fa-light",
    "far": "fa-regular",
    "fas": "fa-solid",
    "fat": "fa-thin"
}), _defineProperty1(_familyProxy3, FAMILY_SHARP, {
    "fass": "fa-solid"
}), _familyProxy3));
var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty1(_familyProxy4, FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), _defineProperty1(_familyProxy4, FAMILY_SHARP, {
    "fa-solid": "fass"
}), _familyProxy4));
var ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss)?[\-\ ]/;
var LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty1(_familyProxy5, FAMILY_CLASSIC, {
    "900": "fas",
    "400": "far",
    "normal": "far",
    "300": "fal",
    "100": "fat"
}), _defineProperty1(_familyProxy5, FAMILY_SHARP, {
    "900": "fass"
}), _familyProxy5));
var oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var oneToTwenty = oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var prefixes = /* @__PURE__ */ new Set();
Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray(prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    DUOTONE_CLASSES.GROUP,
    DUOTONE_CLASSES.SWAP_OPACITY,
    DUOTONE_CLASSES.PRIMARY,
    DUOTONE_CLASSES.SECONDARY
]).concat(oneToTen.map(function(n2) {
    return "".concat(n2, "x");
})).concat(oneToTwenty.map(function(n2) {
    return "w-".concat(n2);
}));
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
    var element = DOCUMENT.querySelector("script[" + attr + "]");
    if (element) {
        return element.getAttribute(attr);
    }
}
function coerce(val) {
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
    attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    attrs.forEach(function(_ref2) {
        var _ref22 = _slicedToArray1(_ref2, 2), attr = _ref22[0], key = _ref22[1];
        var val = coerce(getAttrConfig(attr));
        if (val !== void 0 && val !== null) {
            initial[key] = val;
        }
    });
}
var attrs;
var _default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: DEFAULT_CSS_PREFIX,
    replacementClass: DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
if (initial.familyPrefix) {
    initial.cssPrefix = initial.familyPrefix;
}
var _config = _objectSpread2(_objectSpread2({}, _default), initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_default).forEach(function(key) {
    Object.defineProperty(config, key, {
        enumerable: true,
        set: function set2(val) {
            _config[key] = val;
            _onChangeCb.forEach(function(cb) {
                return cb(config);
            });
        },
        get: function get2() {
            return _config[key];
        }
    });
});
Object.defineProperty(config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        _config.cssPrefix = val;
        _onChangeCb.forEach(function(cb) {
            return cb(config);
        });
    },
    get: function get() {
        return _config.cssPrefix;
    }
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
    _onChangeCb.push(cb);
    return function() {
        _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
    };
}
var d = UNITS_IN_GRID;
var meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function insertCss(css8) {
    if (!css8 || !IS_DOM) {
        return;
    }
    var style = DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css8;
    var headChildren = DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i2 = headChildren.length - 1; i2 > -1; i2--){
        var child = headChildren[i2];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) {
            beforeChild = child;
        }
    }
    DOCUMENT.head.insertBefore(style, beforeChild);
    return css8;
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0){
        id += idPool[Math.random() * 62 | 0];
    }
    return id;
}
function toArray(obj) {
    var array = [];
    for(var i2 = (obj || []).length >>> 0; i2--;){
        array[i2] = obj[i2];
    }
    return array;
}
function classArray(node) {
    if (node.classList) {
        return toArray(node.classList);
    } else {
        return (node.getAttribute("class") || "").split(" ").filter(function(i2) {
            return i2;
        });
    }
}
function htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat(htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function joinStyles(styles2) {
    return Object.keys(styles2 || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles2[styleName].trim(), ";");
    }, "");
}
function transformIsMeaningful(transform) {
    return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref2) {
    var transform = _ref2.transform, containerWidth = _ref2.containerWidth, iconWidth = _ref2.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && IS_IE) {
        val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
    } else if (startCentered) {
        val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
    } else {
        val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
    }
    val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function css2() {
    var dcp = DEFAULT_CSS_PREFIX;
    var drc = DEFAULT_REPLACEMENT_CLASS;
    var fp = config.cssPrefix;
    var rc = config.replacementClass;
    var s2 = baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s2 = s2.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s2;
}
var _cssInserted = false;
function ensureCss() {
    if (config.autoAddCss && !_cssInserted) {
        insertCss(css2());
        _cssInserted = true;
    }
}
var InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: css2,
                insertCss: ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                ensureCss();
            }
        };
    }
};
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener2() {
    DOCUMENT.removeEventListener("DOMContentLoaded", listener2);
    loaded = 1;
    functions.map(function(fn) {
        return fn();
    });
};
var loaded = false;
if (IS_DOM) {
    loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
    if (!loaded) DOCUMENT.addEventListener("DOMContentLoaded", listener);
}
function domready(fn) {
    if (!IS_DOM) return;
    loaded ? setTimeout(fn, 0) : functions.push(fn);
}
function toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") {
        return htmlEscape(abstractNodes);
    } else {
        return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(""), "</").concat(tag, ">");
    }
}
function iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
        return {
            prefix: prefix,
            iconName: iconName,
            icon: mapping[prefix][iconName]
        };
    }
}
var bindInternal4 = function bindInternal42(func, thisContext) {
    return function(a, b, c, d2) {
        return func.call(thisContext, a, b, c, d2);
    };
};
var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== void 0 ? bindInternal4(fn, thisContext) : fn, i2, key, result;
    if (initialValue === void 0) {
        i2 = 1;
        result = subject[keys[0]];
    } else {
        i2 = 0;
        result = initialValue;
    }
    for(; i2 < length; i2++){
        key = keys[i2];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
function ucs2decode(string) {
    var output = [];
    var counter3 = 0;
    var length = string.length;
    while(counter3 < length){
        var value = string.charCodeAt(counter3++);
        if (value >= 55296 && value <= 56319 && counter3 < length) {
            var extra = string.charCodeAt(counter3++);
            if ((extra & 64512) == 56320) {
                output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
            } else {
                output.push(value);
                counter3--;
            }
        } else {
            output.push(value);
        }
    }
    return output;
}
function toHex(unicode) {
    var decoded = ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 55296 && first <= 56319 && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 56320 && second <= 57343) {
            return (first - 55296) * 1024 + second - 56320 + 65536;
        }
    }
    return first;
}
function normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon3 = icons[iconName];
        var expanded = !!icon3.icon;
        if (expanded) {
            acc[icon3.iconName] = icon3.icon;
        } else {
            acc[iconName] = icon3;
        }
        return acc;
    }, {});
}
function defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = normalizeIcons(icons);
    if (typeof namespace.hooks.addPack === "function" && !skipHooks) {
        namespace.hooks.addPack(prefix, normalizeIcons(icons));
    } else {
        namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
    }
    if (prefix === "fas") {
        defineIcons("fa", icons);
    }
}
var _LONG_STYLE;
var _PREFIXES;
var _PREFIXES_FOR_FAMILY;
var styles = namespace.styles;
var shims = namespace.shims;
var LONG_STYLE = (_LONG_STYLE = {}, _defineProperty1(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty1(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = (_PREFIXES = {}, _defineProperty1(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty1(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);
function isReserved(name) {
    return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !isReserved(iconName)) {
        return iconName;
    } else {
        return null;
    }
}
var build = function build2() {
    var lookup = function lookup2(reducer) {
        return reduce(styles, function(o2, style, prefix) {
            o2[prefix] = reduce(style, reducer, {});
            return o2;
        }, {});
    };
    _byUnicode = lookup(function(acc, icon3, iconName) {
        if (icon3[3]) {
            acc[icon3[3]] = iconName;
        }
        if (icon3[2]) {
            var aliases = icon3[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    _byLigature = lookup(function(acc, icon3, iconName) {
        acc[iconName] = iconName;
        if (icon3[2]) {
            var aliases = icon3[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    _byAlias = lookup(function(acc, icon3, iconName) {
        var aliases = icon3[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    });
    var hasRegular = "far" in styles || config.autoFetchSvg;
    var shimLookups = reduce(shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) {
            prefix = "fas";
        }
        if (typeof maybeNameMaybeUnicode === "string") {
            acc.names[maybeNameMaybeUnicode] = {
                prefix: prefix,
                iconName: iconName
            };
        }
        if (typeof maybeNameMaybeUnicode === "number") {
            acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
                prefix: prefix,
                iconName: iconName
            };
        }
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    _byOldName = shimLookups.names;
    _byOldUnicode = shimLookups.unicodes;
    _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
        family: config.familyDefault
    });
};
onChange(function(c) {
    _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault, {
        family: config.familyDefault
    });
});
build();
function byUnicode(prefix, unicode) {
    return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
    return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
    return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
    return _byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function byOldUnicode(unicode) {
    var oldUnicode = _byOldUnicode[unicode];
    var newUnicode = byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function getDefaultUsablePrefix() {
    return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon2() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? FAMILY_CLASSIC : _params$family;
    var style = PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty1(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty1(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
function getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, _defineProperty1(_famProps, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty1(_famProps, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = FAMILY_CLASSIC;
    if (values.includes(famProps[FAMILY_CLASSIC]) || values.some(function(v) {
        return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(v);
    })) {
        family = FAMILY_CLASSIC;
    }
    if (values.includes(famProps[FAMILY_SHARP]) || values.some(function(v) {
        return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(v);
    })) {
        family = FAMILY_SHARP;
    }
    var canonical = values.reduce(function(acc, cls) {
        var iconName = getIconName(config.cssPrefix, cls);
        if (styles[cls]) {
            cls = LONG_STYLE[family].includes(cls) ? LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if (PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) {
            acc.iconName = iconName;
        } else if (cls !== config.replacementClass && cls !== famProps[FAMILY_CLASSIC] && cls !== famProps[FAMILY_SHARP]) {
            acc.rest.push(cls);
        }
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? byOldName(acc.iconName) : {};
            var aliasIconName = byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) {
                givenPrefix = null;
            }
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !styles["far"] && styles["fas"] && !config.autoFetchSvg) {
                acc.prefix = "fas";
            }
        }
        return acc;
    }, emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) {
        canonical.prefix = "fab";
    }
    if (values.includes("fa-duotone") || values.includes("fad")) {
        canonical.prefix = "fad";
    }
    if (!canonical.prefix && family === FAMILY_SHARP && (styles["fass"] || config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") {
        canonical.prefix = getDefaultUsablePrefix() || "fas";
    }
    return canonical;
}
var Library = /* @__PURE__ */ function() {
    function Library2() {
        _classCallCheck(this, Library2);
        this.definitions = {};
    }
    _createClass(Library2, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++){
                    definitions[_key] = arguments[_key];
                }
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    defineIcons(key, additions[key]);
                    var longPrefix = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][key];
                    if (longPrefix) defineIcons(longPrefix, additions[key]);
                    build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon3 = _normalized$key.icon;
                    var aliases = icon3[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) {
                        aliases.forEach(function(alias) {
                            if (typeof alias === "string") {
                                additions[prefix][alias] = icon3;
                            }
                        });
                    }
                    additions[prefix][iconName] = icon3;
                });
                return additions;
            }
        }
    ]);
    return Library2;
}();
var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref2) {
    var obj = _ref2.mixoutsTo;
    _plugins = nextPlugins;
    _hooks = {};
    Object.keys(providers).forEach(function(k) {
        if (defaultProviderKeys.indexOf(k) === -1) {
            delete providers[k];
        }
    });
    _plugins.forEach(function(plugin) {
        var mixout8 = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout8).forEach(function(tk) {
            if (typeof mixout8[tk] === "function") {
                obj[tk] = mixout8[tk];
            }
            if (_typeof1(mixout8[tk]) === "object") {
                Object.keys(mixout8[tk]).forEach(function(sk) {
                    if (!obj[tk]) {
                        obj[tk] = {};
                    }
                    obj[tk][sk] = mixout8[tk][sk];
                });
            }
        });
        if (plugin.hooks) {
            var hooks8 = plugin.hooks();
            Object.keys(hooks8).forEach(function(hook) {
                if (!_hooks[hook]) {
                    _hooks[hook] = [];
                }
                _hooks[hook].push(hooks8[hook]);
            });
        }
        if (plugin.provides) {
            plugin.provides(providers);
        }
    });
    return obj;
}
function chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var hookFns = _hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args));
    });
    return accumulator;
}
function callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++){
        args[_key2 - 1] = arguments[_key2];
    }
    var hookFns = _hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return void 0;
}
function callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return providers[hook] ? providers[hook].apply(null, args) : void 0;
}
function findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") {
        iconLookup.prefix = "fas";
    }
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = byAlias(prefix, iconName) || iconName;
    return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto2() {
    config.autoReplaceSvg = false;
    config.observeMutations = false;
    callHooks("noAuto");
};
var dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (IS_DOM) {
            callHooks("beforeI2svg", params);
            callProvided("pseudoElements2svg", params);
            return callProvided("i2svg", params);
        } else {
            return Promise.reject("Operation requires a DOM of some kind.");
        }
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if (config.autoReplaceSvg === false) {
            config.autoReplaceSvg = true;
        }
        config.observeMutations = true;
        domready(function() {
            autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            callHooks("watch", params);
        });
    }
};
var parse = {
    icon: function icon(_icon) {
        if (_icon === null) {
            return null;
        }
        if (_typeof1(_icon) === "object" && _icon.prefix && _icon.iconName) {
            return {
                prefix: _icon.prefix,
                iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
            };
        }
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
                iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var api = {
    noAuto: noAuto,
    config: config,
    dom: dom,
    parse: parse,
    library: library,
    findIconDefinition: findIconDefinition,
    toHtml: toHtml
};
var autoReplace = function autoReplace2() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get2() {
            return val.abstract.map(function(a) {
                return toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get2() {
            if (!IS_DOM) return;
            var container = DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function asIcon(_ref2) {
    var children = _ref2.children, main = _ref2.main, mask = _ref2.mask, attributes = _ref2.attributes, styles2 = _ref2.styles, transform = _ref2.transform;
    if (transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = joinStyles(_objectSpread2(_objectSpread2({}, styles2), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function asSymbol(_ref2) {
    var prefix = _ref2.prefix, iconName = _ref2.iconName, children = _ref2.children, attributes = _ref2.attributes, symbol = _ref2.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref2 = mask.found ? mask : main, width = _ref2.width, height = _ref2.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        config.replacementClass,
        iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 16 * 0.0625, "em")
    } : {};
    if (watchable) {
        content.attributes[DATA_FA_I2SVG] = "";
    }
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = _objectSpread2(_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref22 = mask.found && main.found ? callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref22.children, attributes = _ref22.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) {
        return asSymbol(args);
    } else {
        return asIcon(args);
    }
}
function makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) {
        attributes[DATA_FA_I2SVG] = "";
    }
    var styles2 = _objectSpread2({}, extra.styles);
    if (transformIsMeaningful(transform)) {
        styles2["transform"] = transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles2["-webkit-transform"] = styles2["transform"];
    }
    var styleString = joinStyles(styles2);
    if (styleString.length > 0) {
        attributes["style"] = styleString;
    }
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) {
        val.push({
            tag: "span",
            attributes: {
                class: "sr-only"
            },
            children: [
                title
            ]
        });
    }
    return val;
}
function makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = joinStyles(extra.styles);
    if (styleString.length > 0) {
        attributes["style"] = styleString;
    }
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) {
        val.push({
            tag: "span",
            attributes: {
                class: "sr-only"
            },
            children: [
                title
            ]
        });
    }
    return val;
}
var styles$1 = namespace.styles;
function asFoundIcon(icon3) {
    var width = icon3[0];
    var height = icon3[1];
    var _icon$slice = icon3.slice(4), _icon$slice2 = _slicedToArray1(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) {
        element = {
            tag: "g",
            attributes: {
                class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
            },
            children: [
                {
                    tag: "path",
                    attributes: {
                        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
                        fill: "currentColor",
                        d: vectorData[0]
                    }
                },
                {
                    tag: "path",
                    attributes: {
                        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
                        fill: "currentColor",
                        d: vectorData[1]
                    }
                }
            ]
        };
    } else {
        element = {
            tag: "path",
            attributes: {
                fill: "currentColor",
                d: vectorData
            }
        };
    }
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function maybeNotifyMissing(iconName, prefix) {
    if (!PRODUCTION && !config.showMissingIcons && iconName) {
        console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
    }
}
function findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && config.styleDefault !== null) {
        prefix = getDefaultUsablePrefix();
    }
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
            var icon3 = styles$1[prefix][iconName];
            return resolve(asFoundIcon(icon3));
        }
        maybeNotifyMissing(iconName, prefix);
        resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
            icon: config.showMissingIcons && iconName ? callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var noop$1 = function noop4() {};
var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
    mark: noop$1,
    measure: noop$1
};
var preamble = 'FA "6.2.0"';
var begin = function begin2(name) {
    p.mark("".concat(preamble, " ").concat(name, " begins"));
    return function() {
        return end(name);
    };
};
var end = function end2(name) {
    p.mark("".concat(preamble, " ").concat(name, " ends"));
    p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
    begin: begin,
    end: end
};
var noop$2 = function noop5() {};
function isWatched(node) {
    var i2svg2 = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
    return typeof i2svg2 === "string";
}
function hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
    var icon3 = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
    return prefix && icon3;
}
function hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}
function getMutator() {
    if (config.autoReplaceSvg === true) {
        return mutators.replace;
    }
    var mutator = mutators[config.autoReplaceSvg];
    return mutator || mutators.replace;
}
function createElementNS(tag) {
    return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function createElement(tag) {
    return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? createElementNS : createElement : _params$ceFn;
    if (typeof abstractObj === "string") {
        return DOCUMENT.createTextNode(abstractObj);
    }
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild(convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    comment = "".concat(comment, "Font Awesome fontawesome.com ");
    return comment;
}
var mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore(convertSVG(abstract), node);
            });
            if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
                var comment = DOCUMENT.createComment(nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else {
                node.remove();
            }
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1];
        if (~classArray(node).indexOf(config.replacementClass)) {
            return mutators.replace(mutation);
        }
        var forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === config.replacementClass || cls.match(forSvg)) {
                    acc.toSvg.push(cls);
                } else {
                    acc.toNode.push(cls);
                }
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) {
                node.removeAttribute("class");
            } else {
                node.setAttribute("class", splitClasses.toNode.join(" "));
            }
        }
        var newInnerHTML = abstract.map(function(a) {
            return toHtml(a);
        }).join("\n");
        node.setAttribute(DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function performOperationSync(op) {
    op();
}
function perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : noop$2;
    if (mutations.length === 0) {
        callbackFunction();
    } else {
        var frame = performOperationSync;
        if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
            frame = WINDOW.requestAnimationFrame || performOperationSync;
        }
        frame(function() {
            var mutator = getMutator();
            var mark = perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var disabled = false;
function disableObservation() {
    disabled = true;
}
function enableObservation() {
    disabled = false;
}
var mo = null;
function observe(options) {
    if (!MUTATION_OBSERVER) {
        return;
    }
    if (!config.observeMutations) {
        return;
    }
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
    mo = new MUTATION_OBSERVER(function(objects) {
        if (disabled) return;
        var defaultPrefix = getDefaultUsablePrefix();
        toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
                if (config.searchPseudoElements) {
                    pseudoElementsCallback(mutationRecord.target);
                }
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && config.searchPseudoElements) {
                pseudoElementsCallback(mutationRecord.target.parentNode);
            }
            if (mutationRecord.type === "attributes" && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
                } else if (hasBeenReplaced(mutationRecord.target)) {
                    nodeCallback(mutationRecord.target);
                }
            }
        });
    });
    if (!IS_DOM) return;
    mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function disconnect() {
    if (!mo) return;
    mo.disconnect();
}
function styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) {
        val = style.split(";").reduce(function(acc, style2) {
            var styles2 = style2.split(":");
            var prop = styles2[0];
            var value = styles2.slice(1);
            if (prop && value.length > 0) {
                acc[prop] = value.join(":").trim();
            }
            return acc;
        }, {});
    }
    return val;
}
function classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== void 0 ? node.innerText.trim() : "";
    var val = getCanonicalIcon(classArray(node));
    if (!val.prefix) {
        val.prefix = getDefaultUsablePrefix();
    }
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) {
        return val;
    }
    if (val.prefix && innerText.length > 0) {
        val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
    }
    if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
        val.iconName = node.firstChild.data;
    }
    return val;
}
function attributesParser(node) {
    var extraAttributes = toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") {
            acc[attr.name] = attr.value;
        }
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if (config.autoA11y) {
        if (title) {
            extraAttributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
        } else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        styleParser: true
    };
    var _classParser = classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = attributesParser(node);
    var pluginMeta = chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? styleParser(node) : [];
    return _objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var styles$2 = namespace.styles;
function generateMutation(node) {
    var nodeMeta = config.autoReplaceSvg === "nest" ? parseMeta(node, {
        styleParser: false
    }) : parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
        return callProvided("generateLayersText", node, nodeMeta);
    } else {
        return callProvided("generateSvgReplacementMutation", node, nodeMeta);
    }
}
var knownPrefixes = /* @__PURE__ */ new Set();
FAMILIES.map(function(family) {
    knownPrefixes.add("fa-".concat(family));
});
Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
knownPrefixes = _toConsumableArray(knownPrefixes);
function onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!IS_DOM) return Promise.resolve();
    var htmlClassList = DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd2(suffix) {
        return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove2(suffix) {
        return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes2 = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys(styles$2));
    if (!prefixes2.includes("fa")) {
        prefixes2.push("fa");
    }
    var prefixesDomQuery = [
        ".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")
    ].concat(prefixes2.map(function(p2) {
        return ".".concat(p2, ":not([").concat(DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) {
        return Promise.resolve();
    }
    var candidates = [];
    try {
        candidates = toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e3) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else {
        return Promise.resolve();
    }
    var mark = perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = generateMutation(node);
            if (mutation) {
                acc.push(mutation);
            }
        } catch (e3) {
            if (!PRODUCTION) {
                if (e3.name === "MissingIcon") {
                    console.error(e3);
                }
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e3) {
            mark();
            reject(e3);
        });
    });
}
function onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    generateMutation(node).then(function(mutation) {
        if (mutation) {
            perform([
                mutation
            ], callback);
        }
    });
}
function resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) {
            mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
        }
        return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var render = function render2(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon3 = iconDefinition.icon;
    return domVariants(_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if (config.autoA11y) {
            if (title) {
                attributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
            } else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return makeInlineSvgAbstract({
            icons: {
                main: asFoundIcon(icon3),
                mask: mask ? asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles2,
                classes: classes
            }
        });
    });
};
var ReplaceElements = {
    mixout: function mixout2() {
        return {
            icon: resolveIcons(render)
        };
    },
    hooks: function hooks2() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = onTree;
                accumulator.nodeCallback = onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function callback() {} : _params$callback;
            return onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    findIcon(iconName, prefix),
                    mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref2) {
                    var _ref22 = _slicedToArray1(_ref2, 2), main = _ref22[0], mask2 = _ref22[1];
                    resolve([
                        node,
                        makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask2
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles2 = _ref3.styles;
            var styleString = joinStyles(styles2);
            if (styleString.length > 0) {
                attributes["style"] = styleString;
            }
            var nextChild;
            if (transformIsMeaningful(transform)) {
                nextChild = callProvided("generateAbstractTransformGrouping", {
                    main: main,
                    transform: transform,
                    containerWidth: main.width,
                    iconWidth: main.width
                });
            }
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var Layers = {
    mixout: function mixout3() {
        return {
            layer: function layer2(assembler) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return domVariants({
                    type: "layer"
                }, function() {
                    callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat(config.cssPrefix, "-layers")
                                ].concat(_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var LayersCounter = {
    mixout: function mixout4() {
        return {
            counter: function counter3(content) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
                return domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles2,
                            classes: [
                                "".concat(config.cssPrefix, "-layers-counter")
                            ].concat(_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var LayersText = {
    mixout: function mixout5() {
        return {
            text: function text2(content) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
                return domVariants({
                    type: "text",
                    content: content
                }, function() {
                    callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return makeLayersTextAbstract({
                        content: content,
                        transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles2,
                            classes: [
                                "".concat(config.cssPrefix, "-layers-text")
                            ].concat(_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides2(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if (IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if (config.autoA11y && !title) {
                extra.attributes["aria-hidden"] = "true";
            }
            return Promise.resolve([
                node,
                makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function hexValueFromContent(content) {
    var cleaned = content.replace(CLEAN_CONTENT_PATTERN, "");
    var codePoint = codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function replaceForPosition(node, position) {
    var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) {
            return resolve();
        }
        var children = toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles2 = WINDOW.getComputedStyle(node, position);
        var fontFamily = styles2.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN);
        var fontWeight = styles2.getPropertyValue("font-weight");
        var content = styles2.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles2.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? FAMILY_SHARP : FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) {
                    node.removeChild(alreadyProcessedPseudoElement);
                }
                var meta = blankMeta();
                var extra = meta.extra;
                extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
                findIcon(iconName, prefix).then(function(main) {
                    var abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = DOCUMENT.createElement("svg");
                    if (position === "::before") {
                        node.insertBefore(element, node.firstChild);
                    } else {
                        node.appendChild(element);
                    }
                    element.outerHTML = abstract.map(function(a) {
                        return toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else {
                resolve();
            }
        } else {
            resolve();
        }
    });
}
function replace2(node) {
    return Promise.all([
        replaceForPosition(node, "::before"),
        replaceForPosition(node, "::after")
    ]);
}
function processable(node) {
    return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function searchPseudoElements(root) {
    if (!IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = toArray(root.querySelectorAll("*")).filter(processable).map(replace2);
        var end3 = perf.begin("searchPseudoElements");
        disableObservation();
        Promise.all(operations).then(function() {
            end3();
            enableObservation();
            resolve();
        }).catch(function() {
            end3();
            enableObservation();
            reject();
        });
    });
}
var PseudoElements = {
    hooks: function hooks3() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides3(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node;
            if (config.searchPseudoElements) {
                searchPseudoElements(node);
            }
        };
    }
};
var _unwatched = false;
var MutationObserver$1 = {
    mixout: function mixout6() {
        return {
            dom: {
                unwatch: function unwatch() {
                    disableObservation();
                    _unwatched = true;
                }
            }
        };
    },
    hooks: function hooks4() {
        return {
            bootstrap: function bootstrap() {
                observe(chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto3() {
                disconnect();
            },
            watch: function watch2(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if (_unwatched) {
                    enableObservation();
                } else {
                    observe(chainHooks("mutationObserverCallbacks", {
                        observeMutationsRoot: observeMutationsRoot
                    }));
                }
            }
        };
    }
};
var parseTransformString = function parseTransformString2(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n2) {
        var parts = n2.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) {
            return acc;
        }
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var PowerTransforms = {
    mixout: function mixout7() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks5() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) {
                    accumulator.transform = parseTransformString(transformString);
                }
                return accumulator;
            }
        };
    },
    provides: function provides4(providers2) {
        providers2.generateAbstractTransformGrouping = function(_ref2) {
            var main = _ref2.main, transform = _ref2.transform, containerWidth = _ref2.containerWidth, iconWidth = _ref2.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: _objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: _objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) {
        abstract.attributes.fill = "black";
    }
    return abstract;
}
function deGroup(abstract) {
    if (abstract.tag === "g") {
        return abstract.children;
    } else {
        return [
            abstract
        ];
    }
}
var Masks = {
    hooks: function hooks6() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(" ").map(function(i2) {
                    return i2.trim();
                }));
                if (!mask.prefix) {
                    mask.prefix = getDefaultUsablePrefix();
                }
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides5(providers2) {
        providers2.generateAbstractMask = function(_ref2) {
            var children = _ref2.children, attributes = _ref2.attributes, main = _ref2.main, mask = _ref2.mask, explicitMaskId = _ref2.maskId, transform = _ref2.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map(fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: _objectSpread2({}, trans.inner),
                children: [
                    fillBlack(_objectSpread2({
                        tag: mainPath.tag,
                        attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: _objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: _objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var MissingIconIndicator = {
    provides: function provides6(providers2) {
        var reduceMotion = false;
        if (WINDOW.matchMedia) {
            reduceMotion = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }
        providers2.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            };
            gChildren.push({
                tag: "path",
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) {
                dot.children.push({
                    tag: "animate",
                    attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
                        attributeName: "r",
                        values: "28;14;28;28;14;28;"
                    })
                }, {
                    tag: "animate",
                    attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                        values: "1;0;1;1;0;1;"
                    })
                });
            }
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) {
                gChildren.push({
                    tag: "path",
                    attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                        opacity: "0",
                        d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                    }),
                    children: [
                        {
                            tag: "animate",
                            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                                values: "0;0;1;1;0;0;"
                            })
                        }
                    ]
                });
            }
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var SvgSymbols = {
    hooks: function hooks7() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var plugins = [
    InjectCSS,
    ReplaceElements,
    Layers,
    LayersCounter,
    LayersText,
    PseudoElements,
    MutationObserver$1,
    PowerTransforms,
    Masks,
    MissingIconIndicator,
    SvgSymbols
];
registerPlugins(plugins, {
    mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon2 = api.icon;
var layer = api.layer;
var text = api.text;
var counter = api.counter;
// node_modules/@fortawesome/react-fontawesome/index.es.js
var import_prop_types = __toESM(require_prop_types());
var import_react3 = __toESM(require("react"));
function ownKeys2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread22(target) {
    for(var i2 = 1; i2 < arguments.length; i2++){
        var source = null != arguments[i2] ? arguments[i2] : {};
        i2 % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
            _defineProperty2(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof2(obj) {
    "@babel/helpers - typeof";
    return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof2(obj2) {
        return typeof obj2;
    } : function(obj2) {
        return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof2(obj);
}
function _defineProperty2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectWithoutPropertiesLoose1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i2;
    for(i2 = 0; i2 < sourceKeys.length; i2++){
        key = sourceKeys[i2];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose1(source, excluded);
    var key, i2;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i2 = 0; i2 < sourceSymbolKeys.length; i2++){
            key = sourceSymbolKeys[i2];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _toConsumableArray2(arr) {
    return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread2();
}
function _arrayWithoutHoles2(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray2(arr);
}
function _iterableToArray2(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray2(o2, minLen) {
    if (!o2) return;
    if (typeof o2 === "string") return _arrayLikeToArray2(o2, minLen);
    var n2 = Object.prototype.toString.call(o2).slice(8, -1);
    if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
    if (n2 === "Map" || n2 === "Set") return Array.from(o2);
    if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray2(o2, minLen);
}
function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i2 = 0, arr2 = new Array(len); i2 < len; i2++)arr2[i2] = arr[i2];
    return arr2;
}
function _nonIterableSpread2() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse2 = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull;
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse2,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, _defineProperty2(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), _defineProperty2(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), _defineProperty2(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), _defineProperty2(_classes, "fa-swap-opacity", props.swapOpacity), _classes);
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
function _isNumerical(obj) {
    obj = obj - 0;
    return obj === obj;
}
function camelize(string) {
    if (_isNumerical(string)) {
        return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    });
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var _excluded = [
    "style"
];
function capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
    return style.split(";").map(function(s2) {
        return s2.trim();
    }).filter(function(s2) {
        return s2;
    }).reduce(function(acc, pair) {
        var i2 = pair.indexOf(":");
        var prop = camelize(pair.slice(0, i2));
        var value = pair.slice(i2 + 1).trim();
        prop.startsWith("webkit") ? acc[capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function convert(createElement5, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (typeof element === "string") {
        return element;
    }
    var children = (element.children || []).map(function(child) {
        return convert(createElement5, child);
    });
    var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) {
                    acc.attrs[key.toLowerCase()] = val;
                } else {
                    acc.attrs[camelize(key)] = val;
                }
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = _objectWithoutProperties1(extraProps, _excluded);
    mixins.attrs["style"] = _objectSpread22(_objectSpread22({}, mixins.attrs["style"]), existingStyle);
    return createElement5.apply(void 0, [
        element.tag,
        _objectSpread22(_objectSpread22({}, mixins.attrs), remaining)
    ].concat(_toConsumableArray2(children)));
}
var PRODUCTION2 = false;
try {
    PRODUCTION2 = process.env.NODE_ENV === "production";
} catch (e31) {}
function log() {
    if (!PRODUCTION2 && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function normalizeIconArgs(icon3) {
    if (icon3 && _typeof2(icon3) === "object" && icon3.prefix && icon3.iconName && icon3.icon) {
        return icon3;
    }
    if (parse$1.icon) {
        return parse$1.icon(icon3);
    }
    if (icon3 === null) {
        return null;
    }
    if (icon3 && _typeof2(icon3) === "object" && icon3.prefix && icon3.iconName) {
        return icon3;
    }
    if (Array.isArray(icon3) && icon3.length === 2) {
        return {
            prefix: icon3[0],
            iconName: icon3[1]
        };
    }
    if (typeof icon3 === "string") {
        return {
            prefix: "fas",
            iconName: icon3
        };
    }
}
function objectWithKey(key, value) {
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty2({}, key, value) : {};
}
var FontAwesomeIcon = /* @__PURE__ */ import_react3.default.forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = normalizeIconArgs(iconArgs);
    var classes = objectWithKey("classes", [].concat(_toConsumableArray2(classList(props)), _toConsumableArray2(className.split(" "))));
    var transform = objectWithKey("transform", typeof props.transform === "string" ? parse$1.transform(props.transform) : props.transform);
    var mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
    var renderedIcon = icon2(iconLookup, _objectSpread22(_objectSpread22(_objectSpread22(_objectSpread22({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
            extraProps[key] = props[key];
        }
    });
    return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
    beat: import_prop_types.default.bool,
    border: import_prop_types.default.bool,
    beatFade: import_prop_types.default.bool,
    bounce: import_prop_types.default.bool,
    className: import_prop_types.default.string,
    fade: import_prop_types.default.bool,
    flash: import_prop_types.default.bool,
    mask: import_prop_types.default.oneOfType([
        import_prop_types.default.object,
        import_prop_types.default.array,
        import_prop_types.default.string
    ]),
    maskId: import_prop_types.default.string,
    fixedWidth: import_prop_types.default.bool,
    inverse: import_prop_types.default.bool,
    flip: import_prop_types.default.oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: import_prop_types.default.oneOfType([
        import_prop_types.default.object,
        import_prop_types.default.array,
        import_prop_types.default.string
    ]),
    listItem: import_prop_types.default.bool,
    pull: import_prop_types.default.oneOf([
        "right",
        "left"
    ]),
    pulse: import_prop_types.default.bool,
    rotation: import_prop_types.default.oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: import_prop_types.default.bool,
    size: import_prop_types.default.oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: import_prop_types.default.bool,
    spinPulse: import_prop_types.default.bool,
    spinReverse: import_prop_types.default.bool,
    symbol: import_prop_types.default.oneOfType([
        import_prop_types.default.bool,
        import_prop_types.default.string
    ]),
    title: import_prop_types.default.string,
    titleId: import_prop_types.default.string,
    transform: import_prop_types.default.oneOfType([
        import_prop_types.default.string,
        import_prop_types.default.object
    ]),
    swapOpacity: import_prop_types.default.bool
};
FontAwesomeIcon.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var convertCurry = convert.bind(null, import_react3.default.createElement);
// src/components/Icon/Icon.tsx
var import_styled_components3 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var small = import_styled_components3.css(_templateObject12());
var regular = import_styled_components3.css(_templateObject13());
var large = import_styled_components3.css(_templateObject14());
var xLarge = import_styled_components3.css(_templateObject15());
var IconWithSize = (0, import_styled_components3.default)(FontAwesomeIcon)(_templateObject16(), function(props) {
    return props.$size === "small" && small;
}, function(props) {
    return props.$size === "regular" && regular;
}, function(props) {
    return props.$size === "large" && large;
}, function(props) {
    return props.$size === "x-large" && xLarge;
}, function(param) {
    var $colorToken = param.$colorToken;
    return "color: var(--".concat($colorToken, ")");
});
var Icon = function(_param) {
    var _colorToken = _param.colorToken, colorToken = _colorToken === void 0 ? "" : _colorToken, icon3 = _param.icon, _size = _param.size, size = _size === void 0 ? "regular" : _size, unhandledProps = _objectWithoutProperties(_param, [
        "colorToken",
        "icon",
        "size"
    ]);
    if (!icon3) {
        return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconWithSize, _objectSpread({
        $colorToken: colorToken,
        icon: icon3,
        $size: size
    }, unhandledProps));
};
Icon.displayName = "Icon";
var Icon_default = (0, import_styled_components3.default)(Icon)(_templateObject17());
// src/components/ButtonGroup/ButtonGroup.tsx
var import_styled_components5 = __toESM(require("styled-components"));
// src/components/ButtonGroup/styled.ts
var import_styled_components4 = __toESM(require("styled-components"));
var ButtonGroup = import_styled_components4.default.div(_templateObject18());
var styled_default2 = {
    ButtonGroup: ButtonGroup
};
// src/components/ButtonGroup/ButtonGroup.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ButtonGroup2 = function(unhandledProps) {
    var context = useTelemetryContext();
    var ref = useTelemetry("ButtonGroup", context), setStart = ref.setStart, setEnd = ref.setEnd;
    setStart();
    var element = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(styled_default2.ButtonGroup, _objectSpread({}, unhandledProps));
    setEnd();
    return element;
};
ButtonGroup2.displayName = "ButtonGroup";
var ButtonGroup_default = (0, import_styled_components5.default)(ButtonGroup2)(_templateObject19());
// ../../node_modules/@radix-ui/react-primitive/dist/index.module.js
var e = __toESM(require("react"));
// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends1() {
    _extends1 = Object.assign ? Object.assign.bind() : function _extends1(target) {
        for(var i2 = 1; i2 < arguments.length; i2++){
            var source = arguments[i2];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends1.apply(this, arguments);
}
// ../../node_modules/@radix-ui/react-primitive/dist/index.module.js
var r = "div";
var Primitive = /* @__PURE__ */ e.forwardRef(function(o2, i2) {
    var tmp = o2.as, n2 = tmp === void 0 ? r : tmp, a = _objectWithoutProperties(o2, [
        "as"
    ]);
    return e.createElement(n2, _extends1({}, a, {
        ref: i2
    }));
});
// ../../node_modules/@radix-ui/react-context/dist/index.module.js
var e2 = __toESM(require("react"));
function createContext2(t2) {
    var n2 = function n2(t3) {
        var n3 = t3.children, o2 = _objectWithoutProperties(t3, [
            "children"
        ]), u2 = e2.useMemo(function() {
            return o2;
        }, Object.values(o2));
        return e2.createElement(r2.Provider, {
            value: u2
        }, n3);
    };
    var r2 = /* @__PURE__ */ e2.createContext(null);
    return n2.displayName = t2 + "Provider", [
        n2,
        function(n3) {
            var o2 = e2.useContext(r2);
            if (null === o2) throw new Error("`".concat(n3, "` must be used within `").concat(t2, "`"));
            return o2;
        }
    ];
}
// ../../node_modules/@radix-ui/react-progress/dist/index.module.js
var t = __toESM(require("react"));
var ref = _slicedToArray(createContext2("Progress"), 2), n = ref[0], o = ref[1];
var Progress = /* @__PURE__ */ t.forwardRef(function(r2, o2) {
    var p2 = r2.value, c = r2.max, tmp = r2.getValueLabel, d2 = tmp === void 0 ? u : tmp, v = _objectWithoutProperties(r2, [
        "value",
        "max",
        "getValueLabel"
    ]), f = l(c) ? c : 100, x = m(p2, f) ? p2 : null, g = s(x) ? d2(x, f) : void 0;
    return t.createElement(n, {
        value: x,
        max: f
    }, /* @__PURE__ */ t.createElement(Primitive, _extends1({
        "aria-valuemax": f,
        "aria-valuemin": 0,
        "aria-valuenow": s(x) ? x : void 0,
        "aria-valuetext": g,
        role: "progressbar",
        "data-state": i(x, f),
        "data-value": null != x ? x : void 0,
        "data-max": f
    }, v, {
        ref: o2
    })));
});
Progress.propTypes = {
    max: function max(e3, r2, t2) {
        var a = e3[r2], n2 = String(a);
        return a && !l(a) ? new Error(function(e4, r3) {
            return "Invalid prop `max` of value `".concat(e4, "` supplied to `").concat(r3, "`. Only numbers greater than 0 are valid max values. Defaulting to `100`.");
        }(n2, t2)) : null;
    },
    value: function value(e3, r2, t2) {
        var a = e3[r2], n2 = String(a), o2 = l(e3.max) ? e3.max : 100;
        return null == a || m(a, o2) ? null : new Error(function(e4, r3) {
            return "Invalid prop `value` of value `".concat(e4, "` supplied to `").concat(r3, "`. The `value` prop must be:\n  - a positive number\n  - less than the value passed to `max` (or 100 if no `max` prop is set)\n  - `null` if the progress is indeterminate.\n\nDefaulting to `null`.");
        }(n2, t2));
    }
};
var ProgressIndicator = /* @__PURE__ */ t.forwardRef(function(r2, n2) {
    var u2;
    var s2 = o("ProgressIndicator");
    return t.createElement(Primitive, _extends1({
        "data-state": i(s2.value, s2.max),
        "data-value": null !== (u2 = s2.value) && void 0 !== u2 ? u2 : void 0,
        "data-max": s2.max
    }, r2, {
        ref: n2
    }));
});
function u(e3, r2) {
    return "".concat(Math.round(e3 / r2 * 100), "%");
}
function i(e3, r2) {
    return null == e3 ? "indeterminate" : e3 === r2 ? "complete" : "loading";
}
function s(e3) {
    return "number" == typeof e3;
}
function l(e3) {
    return s(e3) && !isNaN(e3) && e3 > 0;
}
function m(e3, r2) {
    return s(e3) && !isNaN(e3) && e3 <= r2 && e3 >= 0;
}
var Root = Progress;
var Indicator = ProgressIndicator;
// src/components/Progress/Progress.tsx
var import_styled_components6 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var ProgressBar = (0, import_styled_components6.default)(Indicator)(_templateObject20(), function(param) {
    var $kind = param.$kind;
    switch($kind){
        case "success":
            return "var(--gradient-green)";
        case "error":
            return "var(--gradient-pink)";
        default:
            return "var(--gradient-blurple)";
    }
});
var Bar = (0, import_styled_components6.default)(Root)(_templateObject21(), function(param) {
    var theme = param.theme;
    var ref;
    return theme === null || theme === void 0 ? void 0 : (ref = theme.color) === null || ref === void 0 ? void 0 : ref.progressBackground;
}, ProgressBar);
var Progress2 = function(_param) {
    var _kind = _param.kind, kind = _kind === void 0 ? "default" : _kind, _max = _param.max, max = _max === void 0 ? 100 : _max, _value = _param.value, value = _value === void 0 ? 0 : _value, unhandledProps = _objectWithoutProperties(_param, [
        "kind",
        "max",
        "value"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Bar, _objectSpreadProps(_objectSpread({
        max: max,
        value: value,
        "aria-label": "Progress bar"
    }, unhandledProps), {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProgressBar, {
            $kind: kind,
            style: {
                width: "".concat(value, "%")
            }
        })
    }));
};
Progress2.displayName = "Progress";
var Progress_default = (0, import_styled_components6.default)(Progress2)(_templateObject22());
// src/components/Section/Section.tsx
var import_styled_components7 = __toESM(require("styled-components"));
var Section = import_styled_components7.default.div(_templateObject23());
Section.displayName = "Section";
var Section_default = Section;
// src/components/Label/Label.tsx
var import_styled_components12 = __toESM(require("styled-components"));
// src/components/Label/styled.tsx
var import_styled_components11 = __toESM(require("styled-components"));
// src/components/Typography/Accent.tsx
var import_styled_components9 = __toESM(require("styled-components"));
// src/components/Typography/Text.tsx
var import_styled_components8 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var mono = import_styled_components8.css(_templateObject24());
var small2 = import_styled_components8.css(_templateObject25());
var regular2 = import_styled_components8.css(_templateObject26());
var large2 = import_styled_components8.css(_templateObject27());
var xLarge2 = import_styled_components8.css(_templateObject28());
var xXLarge = import_styled_components8.css(_templateObject29());
var fwBold = import_styled_components8.css(_templateObject30());
var fwSemibold = import_styled_components8.css(_templateObject31());
var fwRegular = import_styled_components8.css(_templateObject32());
var lsDense = import_styled_components8.css(_templateObject33());
var lsRegular = import_styled_components8.css(_templateObject34());
var lsSpacious = import_styled_components8.css(_templateObject35());
var lhXSmall = import_styled_components8.css(_templateObject36());
var lhSmall = import_styled_components8.css(_templateObject37());
var lhRegular = import_styled_components8.css(_templateObject38());
var lhLarge = import_styled_components8.css(_templateObject39());
var Base = import_styled_components8.default.p(_templateObject40(), function(props) {
    return props.$family === "mono" && mono;
}, function(props) {
    return props.$size === "small" && small2;
}, function(props) {
    return props.$size === "regular" && regular2;
}, function(props) {
    return props.$size === "large" && large2;
}, function(props) {
    return props.$size === "x-large" && xLarge2;
}, function(props) {
    return props.$size === "x-x-large" && xXLarge;
}, function(props) {
    return props.$weight === "bold" && fwBold;
}, function(props) {
    return props.$weight === "semibold" && fwSemibold;
}, function(props) {
    return props.$weight === "regular" && fwRegular;
}, function(props) {
    return props.$letterSpacing === "dense" && lsDense;
}, function(props) {
    return props.$letterSpacing === "regular" && lsRegular;
}, function(props) {
    return props.$letterSpacing === "spacious" && lsSpacious;
}, function(props) {
    return props.$lineHeight === "x-small" && lhXSmall;
}, function(props) {
    return props.$lineHeight === "small" && lhSmall;
}, function(props) {
    return props.$lineHeight === "regular" && lhRegular;
}, function(props) {
    return props.$lineHeight === "large" && lhLarge;
}, function(param) {
    var $colorToken = param.$colorToken;
    return $colorToken && "color: var(--".concat($colorToken, ");");
});
var Text = function(_param) {
    var children = _param.children, colorToken = _param.colorToken, family = _param.family, _letterSpacing = _param.letterSpacing, letterSpacing = _letterSpacing === void 0 ? "regular" : _letterSpacing, _lineHeight = _param.lineHeight, lineHeight = _lineHeight === void 0 ? "regular" : _lineHeight, _size = _param.size, size = _size === void 0 ? "regular" : _size, _weight = _param.weight, weight = _weight === void 0 ? "regular" : _weight, unhandledProps = _objectWithoutProperties(_param, [
        "children",
        "colorToken",
        "family",
        "letterSpacing",
        "lineHeight",
        "size",
        "weight"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Base, _objectSpreadProps(_objectSpread({}, unhandledProps), {
        $colorToken: colorToken,
        $family: family,
        $letterSpacing: letterSpacing,
        $lineHeight: lineHeight,
        $size: size,
        $weight: weight,
        children: children
    }));
};
var Text_default = Text;
// src/components/Typography/Accent.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var AccentText = (0, import_styled_components9.default)(Text_default)(_templateObject41());
var Accent = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, unhandledProps = _objectWithoutProperties(_param, [
        "as"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AccentText, _objectSpreadProps(_objectSpread({}, unhandledProps), {
        colorToken: "color-neutral-600",
        forwardedAs: as,
        letterSpacing: "spacious",
        lineHeight: "large",
        size: "small",
        weight: "bold"
    }));
};
var Accent_default = Accent;
// src/components/Typography/Body100.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Body100 = function(_param) {
    var _bold = _param.bold, bold = _bold === void 0 ? false : _bold, weight = _param.weight, unhandledProps = _objectWithoutProperties(_param, [
        "bold",
        "weight"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Text_default, _objectSpread({
        weight: weight !== null && weight !== void 0 ? weight : bold ? "bold" : "regular"
    }, unhandledProps));
};
var Body100_default = Body100;
// src/components/Typography/Body200.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Body200 = function(_param) {
    var _bold = _param.bold, bold = _bold === void 0 ? false : _bold, weight = _param.weight, unhandledProps = _objectWithoutProperties(_param, [
        "bold",
        "weight"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Text_default, _objectSpread({
        lineHeight: "large",
        size: "small",
        weight: weight !== null && weight !== void 0 ? weight : bold ? "bold" : "regular"
    }, unhandledProps));
};
var Body200_default = Body200;
// src/components/Typography/Code.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Code = function(_param) {
    var unhandledProps = _extends({}, _param);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Text_default, _objectSpreadProps(_objectSpread({}, unhandledProps), {
        family: "mono"
    }));
};
var Code_default = Code;
// src/components/Typography/styled.tsx
var import_styled_components10 = __toESM(require("styled-components"));
var BaseHeading = (0, import_styled_components10.default)(Text_default)(_templateObject42());
// src/components/Typography/Heading100.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Heading100 = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, unhandledProps = _objectWithoutProperties(_param, [
        "as"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseHeading, _objectSpread({
        colorToken: "color-neutral-800",
        forwardedAs: as,
        letterSpacing: "dense",
        lineHeight: "x-small",
        size: "x-x-large",
        weight: "bold"
    }, unhandledProps));
};
var Heading100_default = Heading100;
// src/components/Typography/Heading200.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Heading200 = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, unhandledProps = _objectWithoutProperties(_param, [
        "as"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseHeading, _objectSpread({
        colorToken: "color-neutral-800",
        forwardedAs: as,
        lineHeight: "x-small",
        size: "x-large"
    }, unhandledProps));
};
var Heading200_default = Heading200;
// src/components/Typography/Heading300.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Heading300 = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, unhandledProps = _objectWithoutProperties(_param, [
        "as"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseHeading, _objectSpread({
        colorToken: "color-neutral-800",
        forwardedAs: as,
        lineHeight: "small",
        size: "large",
        weight: "semibold"
    }, unhandledProps));
};
var Heading300_default = Heading300;
// src/components/Typography/Heading.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var variations = {
    100: Heading100_default,
    200: Heading200_default,
    300: Heading300_default
};
var Heading = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, _variant = _param.variant, variant = _variant === void 0 ? "100" : _variant, unhandledProps = _objectWithoutProperties(_param, [
        "as",
        "variant"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    var HeadingStyle = variations[variant];
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(HeadingStyle, _objectSpread({
        as: as
    }, unhandledProps));
};
var Heading_default = Heading;
// src/components/Typography/Paragraph.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var variations2 = {
    100: Body100_default,
    200: Body200_default
};
var Paragraph = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, _bold = _param.bold, bold = _bold === void 0 ? false : _bold, _variant = _param.variant, variant = _variant === void 0 ? "100" : _variant, unhandledProps = _objectWithoutProperties(_param, [
        "as",
        "bold",
        "variant"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    var ParagraphStyle = variations2[variant];
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ParagraphStyle, _objectSpread({
        as: as,
        bold: bold
    }, unhandledProps));
};
var Paragraph_default = Paragraph;
// src/components/Label/styled.tsx
var Wrapper = import_styled_components11.default.label(_templateObject43());
var LabelText = (0, import_styled_components11.default)(Body100_default)(_templateObject44());
var Optional = (0, import_styled_components11.default)(Body100_default)(_templateObject45());
var Interaction = import_styled_components11.default.span(_templateObject46());
// src/components/Label/Label.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Label = function(_param) {
    var children = _param.children, interaction = _param.interaction, _optional = _param.optional, optional = _optional === void 0 ? false : _optional, unhandledProps = _objectWithoutProperties(_param, [
        "children",
        "interaction",
        "optional"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({}, unhandledProps), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LabelText, {
                bold: true,
                children: children
            }),
            optional && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Optional, {
                children: "(optional)"
            }),
            interaction && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Interaction, {
                children: interaction
            })
        ]
    }));
};
Label.displayName = "Label";
var Label_default = (0, import_styled_components12.default)(Label)(_templateObject47());
// src/components/Link/styled.tsx
var import_styled_components13 = __toESM(require("styled-components"));
var Wrapper2 = import_styled_components13.default.a(_templateObject48(), function(param) {
    var $icon = param.$icon, $inline = param.$inline;
    return $icon && ($inline ? "var(--spacing-x-small)" : "var(--spacing-small)");
});
var IconWrapper = import_styled_components13.default.span(_templateObject49(), function(param) {
    var $size = param.$size;
    return $size === "small" ? "var(--icon-size-small)" : "var(--icon-size-regular)";
});
// src/components/Link/Link.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Link = function(_param) {
    var children = _param.children, to = _param.to, icon3 = _param.icon, _inline = _param.inline, inline = _inline === void 0 ? false : _inline, _size = _param.size, size = _size === void 0 ? "regular" : _size, unhandledProps = _objectWithoutProperties(_param, [
        "children",
        "to",
        "icon",
        "inline",
        "size"
    ]);
    var ref = useTelemetryContext(), performance2 = ref.performance;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper2, _objectSpreadProps(_objectSpread({
        href: to,
        rel: icon3 ? "noopener noreferrer" : void 0,
        target: icon3 ? "_blank" : void 0,
        $icon: icon3,
        $inline: inline
    }, unhandledProps), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Text_default, {
                as: "span",
                weight: "bold",
                size: size,
                children: children
            }),
            icon3 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconWrapper, {
                $size: size,
                children: icon3
            })
        ]
    }));
};
Link.displayName = "Link";
var Link_default = Link;
// src/components/Spinner/Spinner.tsx
var import_react4 = require("react");
// src/components/Spinner/styled.ts
var import_styled_components15 = __toESM(require("styled-components"));
// src/components/Spinner/Logo.jsx
var import_styled_components14 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Logo_default = import_styled_components14.default.svg.attrs({
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 107.4",
    style: {
        enableBackground: "new 0 0 86 107.4"
    },
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("g", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("g", {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("g", {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
                        className: "st0",
                        d: "M37.7,58.6l30.1,47.1c0.8,1.1,1.9,1.7,3.3,1.7h11.1c2.1,0,3.8-1.7,3.8-3.8V3.8c0-3.6-4.5-5.2-6.9-2.4\n				L37.7,54C36.8,55.2,36.8,57.2,37.7,58.6z"
                    })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("g", {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
                        className: "st0",
                        d: "M3.9,107.3h19.8c2.1,0,3.8-1.7,3.8-3.8V78.2c0-3.6-4.5-5.2-6.9-2.4L0.8,101.1\n				C-1.1,103.8,0.8,107.3,3.9,107.3z"
                    })
                })
            ]
        })
    })
})(_templateObject50());
// src/components/Spinner/styled.ts
var pulse = import_styled_components15.keyframes(_templateObject51());
var merge = import_styled_components15.keyframes(_templateObject52());
var spinner = import_styled_components15.keyframes(_templateObject53());
var move = function($position) {
    return import_styled_components15.keyframes(_templateObject54(), $position, $position);
};
var grow = function($position) {
    return import_styled_components15.keyframes(_templateObject55(), $position === "top" ? "border-bottom-color: var(--color-blurple-600);" : "border-top-color: var(--color-blurple-600);", $position, $position === "top" ? "border-bottom-color: var(--color-blurple-600);" : "border-top-color: var(--color-blurple-600);\n          ");
};
var Wrapper3 = import_styled_components15.default.div(_templateObject56());
var Rotate = import_styled_components15.default.div(_templateObject57(), pulse, spinner);
var Arc = import_styled_components15.default.div(_templateObject59(), function(param) {
    var $position = param.$position;
    return import_styled_components15.css(_templateObject58(), move($position), grow($position), merge, $position);
});
var IconWrapper2 = import_styled_components15.default.div(_templateObject60(), pulse);
var Icon2 = (0, import_styled_components15.default)(Logo_default)(_templateObject61());
// src/components/Spinner/Spinner.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Spinner = function() {
    var ref = _slicedToArray((0, import_react4.useState)(0), 2), value = ref[0], setValue = ref[1];
    var rotateRef = (0, import_react4.useRef)(null);
    var topRef = (0, import_react4.useRef)(null);
    var bottomRef = (0, import_react4.useRef)(null);
    (0, import_react4.useEffect)(function() {
        var toggle = function() {
            return setValue(function(val) {
                return val > 0 ? 0 : 1;
            });
        };
        var timer = setInterval(toggle, 3600);
        return function() {
            clearInterval(timer);
        };
    }, [
        value
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper3, {
        role: "progressbar",
        "aria-label": "Loading",
        "aria-busy": true,
        "aria-live": "polite",
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Rotate, {
                ref: rotateRef,
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Arc, {
                        $position: "top",
                        ref: topRef
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Arc, {
                        $position: "bottom",
                        ref: bottomRef
                    })
                ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconWrapper2, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon2, {})
            })
        ]
    }, value);
};
Spinner.displayName = "Spinner";
var Spinner_default = Spinner;
// src/components/Input/Input.tsx
var import_react5 = require("react");
// src/components/Input/styled.ts
var import_styled_components16 = __toESM(require("styled-components"));
var ExtensionText = import_styled_components16.css(_templateObject62());
var InputText = import_styled_components16.default.input(_templateObject63());
var Suffix = import_styled_components16.default.span(_templateObject64(), ExtensionText);
var Prefix = import_styled_components16.default.span(_templateObject65(), ExtensionText);
var disabled2 = import_styled_components16.css(_templateObject66(), InputText);
var error = import_styled_components16.css(_templateObject67());
var readOnly = import_styled_components16.css(_templateObject68());
var Action = import_styled_components16.default.button(_templateObject69());
var ContextualIcon = (0, import_styled_components16.default)(Icon_default)(_templateObject70());
var small3 = import_styled_components16.css(_templateObject71(), InputText, Suffix, Prefix, ContextualIcon);
var Wrapper4 = import_styled_components16.default.div(_templateObject72(), function(param) {
    var $error = param.$error;
    return $error && error;
}, function(param) {
    var $readOnly = param.$readOnly;
    return $readOnly && readOnly;
}, function(param) {
    var $disabled = param.$disabled;
    return $disabled && disabled2;
}, function(param) {
    var $size = param.$size;
    return $size === "small" && small3;
});
var ActionWrapper = import_styled_components16.default.div(_templateObject73());
// src/components/Input/Input.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Input = (0, import_react5.forwardRef)(function(_param, ref) {
    var icon3 = _param.icon, action = _param.action, prefix = _param.prefix, suffix = _param.suffix, _size = _param.size, size = _size === void 0 ? "regular" : _size, tmp = _param.error, error3 = tmp === void 0 ? false : tmp, tmp1 = _param.disabled, disabled4 = tmp1 === void 0 ? false : tmp1, tmp2 = _param.readOnly, readOnly3 = tmp2 === void 0 ? false : tmp2, unhandledProps = _objectWithoutProperties(_param, [
        "icon",
        "action",
        "prefix",
        "suffix",
        "size",
        "error",
        "disabled",
        "readOnly"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper4, {
        $error: error3,
        $disabled: disabled4,
        $readOnly: readOnly3,
        $size: size,
        children: [
            icon3 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContextualIcon, {
                icon: icon3
            }),
            prefix && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Prefix, {
                children: prefix
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(InputText, _objectSpread({
                ref: ref,
                disabled: disabled4,
                readOnly: readOnly3
            }, unhandledProps)),
            suffix && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Suffix, {
                children: suffix
            }),
            action && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActionWrapper, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Action, {
                    children: action
                })
            })
        ]
    });
});
var Input_default = Input;
// src/components/InlineMessage/InlineMessage.tsx
var import_styled_components18 = __toESM(require("styled-components"));
// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faCircleExclamation = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm32 224c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
// src/components/InlineMessage/styled.ts
var import_styled_components17 = __toESM(require("styled-components"));
var Wrapper5 = (0, import_styled_components17.default)(Body100_default)(_templateObject74(), function(props) {
    return props.$variant === "helper" && "color: var(--color-neutral-700);";
}, function(props) {
    return props.$variant === "error" && "color: var(--color-pink-600);";
});
var PrefixIcon = (0, import_styled_components17.default)(Icon_default)(_templateObject75(), function(props) {
    return props.$variant === "error" && "color: var(--color-pink-600);";
});
// src/components/InlineMessage/InlineMessage.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var InlineMessage = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "helper" : _variant, icon3 = param.icon, children = param.children, className = param.className;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper5, {
        $variant: variant,
        className: className,
        children: [
            (icon3 !== null && icon3 !== void 0 ? icon3 : variant === "error") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PrefixIcon, {
                icon: icon3 !== null && icon3 !== void 0 ? icon3 : faCircleExclamation
            }),
            children
        ]
    });
};
var InlineMessage_default = (0, import_styled_components18.default)(InlineMessage)(_templateObject76());
// src/components/TextArea/TextArea.tsx
var import_react6 = require("react");
// src/components/TextArea/styled.ts
var import_styled_components19 = __toESM(require("styled-components"));
var TextAreaInput = import_styled_components19.default.textarea(_templateObject77());
var disabled3 = import_styled_components19.css(_templateObject78(), TextAreaInput);
var error2 = import_styled_components19.css(_templateObject79());
var readOnly2 = import_styled_components19.css(_templateObject80());
var Counter = (0, import_styled_components19.default)(Paragraph_default).attrs({
    as: "span"
})(_templateObject81());
var small4 = import_styled_components19.css(_templateObject82(), TextAreaInput, Counter, Counter);
var counter2 = import_styled_components19.css(_templateObject83(), TextAreaInput);
var Wrapper6 = import_styled_components19.default.div(_templateObject84(), function(param) {
    var $counter = param.$counter;
    return $counter && counter2;
}, function(param) {
    var $error = param.$error;
    return $error && error2;
}, function(param) {
    var $readOnly = param.$readOnly;
    return $readOnly && readOnly2;
}, function(param) {
    var $disabled = param.$disabled;
    return $disabled && disabled3;
}, function(param) {
    var $size = param.$size;
    return $size === "small" && small4;
});
// src/components/TextArea/TextArea.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TextArea = (0, import_react6.forwardRef)(function(_param, ref) {
    var children = _param.children, counter3 = _param.counter, _size = _param.size, size = _size === void 0 ? "regular" : _size, tmp = _param.error, error3 = tmp === void 0 ? false : tmp, tmp1 = _param.disabled, disabled4 = tmp1 === void 0 ? false : tmp1, tmp2 = _param.readOnly, readOnly3 = tmp2 === void 0 ? false : tmp2, unhandledProps = _objectWithoutProperties(_param, [
        "children",
        "counter",
        "size",
        "error",
        "disabled",
        "readOnly"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper6, {
        $error: error3,
        $disabled: disabled4,
        $readOnly: readOnly3,
        $size: size,
        $counter: counter3,
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextAreaInput, _objectSpreadProps(_objectSpread({
                ref: ref,
                disabled: disabled4,
                readOnly: readOnly3
            }, unhandledProps), {
                children: children
            })),
            counter3 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Counter, {
                variant: size === "small" ? "200" : "100",
                children: counter3
            })
        ]
    });
});
var TextArea_default = TextArea;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    Accent: Accent,
    Body100: Body100,
    Body200: Body200,
    Button: Button,
    ButtonGroup: ButtonGroup,
    Code: Code,
    Heading: Heading,
    Heading100: Heading100,
    Heading200: Heading200,
    Heading300: Heading300,
    Icon: Icon,
    InlineMessage: InlineMessage,
    Input: Input,
    Label: Label,
    Link: Link,
    Paragraph: Paragraph,
    Progress: Progress,
    Section: Section,
    Spinner: Spinner,
    Text: Text,
    TextArea: TextArea
}); /*
object-assign
(c) Sindre Sorhus
@license MIT
*/  /** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */  /** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
//# sourceMappingURL=index.js.map